
var $=jQuery;
var may_like_mySwiper_m='';
var quick_shop_swiper; // 声明在全局作用域
var customerId='';
var email='';
var detail_product_id=$('.product_cen_detail').attr('id');
var clickTimer = null;
if (window.customerData && window.customerData.loggedIn) {
  console.log("用户邮箱:", window.customerData.email);
  customerId=window.customerData.email;
  email=window.customerData.email;
} else {
  console.log("用户未登录");
}
var url = window.location.href;

var product_ids=sessionStorage.getItem('recommend_products_ids') || '';
var card_id=sessionStorage.getItem('recommend_card_id') || '';
var recommend_products=sessionStorage.getItem('recommend_products');
window.getGaClientId = function () {
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      if (ca[i].match(/^\s*_ga=GA.*/g)) {
          var gid = ca[i];
          break;
      }
  }
  var clientId = gid ? gid.replace(/_ga=GA.\..\./, "") :'';
  return clientId;
}
var clientId = getGaClientId();

// 定义一个标志变量来控制是否执行滚动事件处理函数
var allowScrollHandler = true;

jQuery(function(){
  jQuery(window).resize(function(){
    if(jQuery(window).width()>=769){
      $('#sidebar-menu').hide();
    }
  })
  if(window.location.pathname.indexOf("/collections") >= 0 ){
    setTimeout(function(){
      $('section[data-section-type="recently-viewed-products"] .ProductItem').each(function(){
        jQuery(this).find('.ProductItem__PriceList .addCart_icon').off("click").on("click",function(){
          let $this = $(this);
          if ($this.hasClass("disabled")) return; // 已禁用，不执行
      
          $this.addClass("disabled"); // 禁用点击
          setTimeout(() => {
              $this.removeClass("disabled"); // 2秒后恢复
          }, 5000);
          if ($('.quick_shop_main').is(':visible')) {
            console.log('quick_shop_main 是显示的');
            $this.addClass("disabled"); // 禁用点击
          } else {
              console.log('quick_shop_main 是隐藏的（display: none 或 visibility: hidden）',$('.quick_shop_main').css('display'));
              quick_icon_click(jQuery(this),jQuery(this).parent().siblings().find('a').attr('href'));
    
          }
        
  
          })
      })
    },3000)

  }
  if(window.location.pathname == '/'){
    // 判断是不是从详情页返
    // 在页面加载时检查状态
    if (sessionStorage.getItem('popupVisible')) {
    }else{
      $('.video_poupop .window-cover').css('display','none');
      $('.video_poupop .video_poupop_cen').css('display','none');
    }
  }
  // 在智能推荐页面
  var recommend_more_click_num=0;
  var recommend_more_jiazai_num=0;
  var scrol_flag=false;
  let lastExecutionTime = 0;
  if(window.location.pathname == '/collections/recommend-hair-for-you'){
    var recommend_more_scrollThreshold = 100; // 滚动的阈值，每滚动200像素调用一次函数
    // 滚动事件处理函数
    var recommend_more_lastScrollTop = 0;
     if(recommend_more_jiazai_num==0){
      recommend_products_view_more();
    }

    let debounceTimer;

    $(window).on('scroll', function() {
        clearTimeout(debounceTimer);
    
        debounceTimer = setTimeout(function() {
            // 执行你的滑动逻辑
           recommend_more_scrollEventHandler()
        }, 200); // 200 毫秒
    });
    
    function recommend_more_scrollEventHandler() {     
       const currentTime = new Date().getTime();
    
      if (currentTime - lastExecutionTime > 200) { // 200 毫秒
          lastExecutionTime = currentTime;
  
          // 执行你的滑动逻辑
          if (!allowScrollHandler) {
              return;
          }
          // 获取当前滚动条的位置
          var recommend_more_scrollTop =  $(window).scrollTop();
          // 判断滚动的距离是否超过阈值，并且是向下滚动
              // 在这里编写原来的滚动事件处理逻辑
          if (recommend_more_scrollTop > recommend_more_lastScrollTop && (recommend_more_scrollTop - recommend_more_lastScrollTop) >= recommend_more_scrollThreshold) {
            
            recommend_more_jiazai_num+=1;
              // 调用需要执行的函数
              // 更新上次滚动的位置
                recommend_more_lastScrollTop = $(window).scrollTop();
                setTimeout(() => {
                  scrol_flag=true;
                  recommend_products_view_more();
                }, 1000); // 2000 毫秒
  
                
       
          }
      }

    }
    
  }
  // 点击首页智能推荐点击view more
  function recommend_products_view_more(){
    if(recommend_more_click_num==0){
      recommend_more_click_num+=1;
    }
    console.log('加载次数',recommend_more_click_num);
    var form = new FormData();
    form.append("ids", product_ids);
    form.append("all_cards", card_id);
    if(recommend_more_click_num>1){
      form.append("page", recommend_more_click_num);
    }
    if(recommend_more_click_num<9){
      $.ajax({
        "url": "https://plugin.kriyya.com/api/klaiyi/recommend_products_view_more",
        "method": "POST",
        "timeout": 0,
        "headers": {
          "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5"
        },
        "processData": false,
        "mimeType": "multipart/form-data",
        "contentType": false,
        "data": form,
        success: function(res) {
          console.log('智能推荐返回值',JSON.parse(res).nextPage);
          recommend_more_click_num = JSON.parse(res).nextPage;
          if(recommend_more_click_num>2){
            $('.recommend-hair-for-you .ProductListWrapper .ProductList').append(JSON.parse(res).content);
          }else{
            $('.recommend-hair-for-you .ProductListWrapper').html(JSON.parse(res).content);
          }
          $('.recommend-hair-for-you .Grid__Cell .addCart_icon').each(function(){
            $(this).off("click").on("click",function(){
              console.log('点击加购按钮');
              let $this = $(this);
              if ($this.hasClass("disabled")) return; // 已禁用，不执行
          
              $this.addClass("disabled"); // 禁用点击
              setTimeout(() => {
                  $this.removeClass("disabled"); // 2秒后恢复
              }, 5000);

              if ($('.quick_shop_main').is(':visible')) {
                console.log('quick_shop_main 是显示的');
                $this.addClass("disabled"); // 禁用点击
              } else {
                  console.log('quick_shop_main 是隐藏的（display: none 或 visibility: hidden）',$('.quick_shop_main').css('display'));
                  quick_icon_click(jQuery(this),jQuery(this).parent().siblings().find('a').attr('href'));
        
              }
              
            })
          })
      },
        error:function(req){
          console.log('错误返回值',req);
        }
      });
    }

  }
  
    if(url.indexOf("/products/") >= 0 ) { 
          console.log('进入详情页');
          window.addEventListener('scroll', function() {
            // 当滚动条与顶部的距离超过一定数值时，执行你的代码
            if(window.scrollY > 0) {
                // 这里执行你的代码
                console.log('页面开始滚动');
                product_scrol();
                // 如果你只想执行一次，可以在这里移除事件监听器
                window.removeEventListener('scroll', arguments.callee);
            }
        });
    }
})
function product_scrol(){
     // 详情智能推荐
      intelligent_recommend_product_detail( clientId , email);
}
function intelligent_recommend_product_detail( clientId, email) {
  var now = new Date(); // 获取当前日期和时间
   var dateString = now.toLocaleString(); // 将日期和时间转换为字符串
     clientId ? clientId : '';
     email ?  email : '';
   dateString ? dateString : '';
   var form = new FormData();
   form.append("cid", clientId);
   form.append("email", email);
   form.append("product_id", detail_product_id);
    form.append("shop_name", 'klaiyi');
   form.append("dateString", dateString);
   if(product_ids){
    form.append("ids", product_ids);
    form.append("card_id", card_id);
   }
   $.ajax({
     "url": "https://plugin.kriyya.com/api/klaiyi/recommend_products_view",
     "method": "POST",
     "timeout": 0,
     "headers": {
       "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5"
     },
     "processData": false,
     "mimeType": "multipart/form-data",
     "contentType": false,
     "data": form,
     success: function(res) {
        if(jQuery(window).width()<=768){
              $('.m_may_like .ProductListWrapper .swiper-wrapper').html(JSON.parse(res).content);
           // 更新m详情智能推荐
            if ($('.m_may_like .swiper-container').length && typeof Swiper !== 'undefined' && $('.m_may_like .swiper-container').swiper) {
              if(may_like_mySwiper_m){
                may_like_mySwiper_m.update();
              }
              
              // 设置观察器
              transverse_product_setupObserver('detail_recommend_slide_m');
            }
             

         }
          if(jQuery(window).width()>=769){
            $('.pc_may_like .may_like_product2_detail .ProductListWrapper').html(JSON.parse(res).content);
            if ($('.pc_may_like .swiper-container').length && typeof Swiper !== 'undefined' && $('.pc_may_like .swiper-container').swiper) {
              console.log('Swiper 已初始化并执行');
                var may_like_mySwiper_pc = new Swiper('.may_like_product2_detail',{
                  slidesPerView: 4,
                  paginationClickable: true,
                  spaceBetween: 20,
                  nextButton: '.swiper-button_next_pc_may_like',
                  prevButton: '.swiper-button_prev_pc_may_like',
              })
              transverse_product_setupObserver('detail_recommend_slide_pc');
            } else {
               console.log('Swiper 未初始化或未执行');
            }

          }
        $('.may_like .ProductListWrapper .ProductItem .addCart_icon').each(function(){
          $(this).off("click").on("click",function(){
            let $this = $(this);
            if ($this.hasClass("disabled")) return; // 已禁用，不执行
        
            $this.addClass("disabled"); // 禁用点击
            setTimeout(() => {
                $this.removeClass("disabled"); // 2秒后恢复
            }, 5000);

            if ($('.quick_shop_main').is(':visible')) {
              console.log('quick_shop_main 是显示的');
              $this.addClass("disabled"); // 禁用点击
            } else {
                console.log('quick_shop_main 是隐藏的（display: none 或 visibility: hidden）',$('.quick_shop_main').css('display'));
                quick_icon_click(jQuery(this),jQuery(this).parent().siblings().find('a').attr('href'));
      
            }
            
          })
        })
           $('img.pic_site').each(function () {
             $(this).attr('src', $(this).attr('data-src'));
           })
     },
     error:function(req){
       console.log('错误返回值',req);
     }
   });

}
if($.cookie("poupon_num")){
 var poupon_num = $.cookie("poupon_num");
}else{
  var poupon_num = 0;
}

// 曝光逻辑
// 详情推荐产品曝光
function transverse_product_setupObserver(detail_slideId) {
  console.log('曝光的内容',detail_slideId);
  const observerOptions = {
    root: null, // 使用 viewport 作为根
    rootMargin: '0px', // 根边距
    threshold: 0.1 // 10% 的可见面积
  };

  const transverse_product_observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const productElement = entry.target;
        const productId = productElement.dataset.productId;
        const transverse_product_title = productElement.querySelector('.ptit')?.innerText;
        const transverse_product_price = productElement.querySelector('.Price--highlight .money')?.innerText;
        const transverse_product_index = productElement.parentElement.getAttribute('data-index');
        console.log('产品的key',transverse_product_index,'--',productElement.parentElement.getAttribute('data-index'));
        trackExposure(productId, transverse_product_title,transverse_product_index, transverse_product_price, detail_slideId);

        // 停止观察以防止重复曝光
        transverse_product_observer.unobserve(productElement);
      }
    });
  }, observerOptions);

  // 获取模块中的所有产品元素
  const productElements = document.querySelectorAll(`.${detail_slideId} .swiper-slide .ProductItem`);
  
  // 为每个产品元素添加观察
  productElements.forEach(product => {
    transverse_product_observer.observe(product);
  });
}

function trackExposure(productId, product_title,product_index,product_price, detail_slideId) {
    console.log(`曝光产品 [模块 ${detail_slideId}]:`, {
        id: productId,
        image: product_title,
        alt: product_price,
        index: product_index
    });
    if(detail_slideId =='detail_recommend_slide_pc' || detail_slideId =='detail_recommend_slide_m'){
        DataLyer_push_product('ProductDetail_Recommendation_recommend',product_title,productId,product_price,'productDetail',product_index);
    }

  // 在这里添加其他曝光处理逻辑，例如发送 AJAX 请求
}
function DataLyer_push_product(collection_name,product_name,product_id,total_price,collection_id,index) {
  console.log('当前产品的信息',collection_name,product_name,product_id,total_price,collection_id,index);
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
  event: "dle_view_item_list",
  dlv_ec: 'productDetail',
  dlv_ea: 'productView',
  dlv_el: collection_name,
  ecommerce: {
    items: [{
      item_name: product_name,
      item_id: product_id,
      price: total_price,
      item_category: '',
      item_list_name: collection_name,
      index: index,
      quantity: `1`,
      currency: 'USD',
    }]
  }
  });
}

// 详情推荐产品曝光结束

var close_popon5_interval;
var add_product_interval;
var t = new Date();
  t.setDate(t.getDate()+1);
  t.setHours(0);
  t.setMinutes(0);
  t.setSeconds(0);
jQuery(function(){
  if(window.location.pathname.indexOf("/collections") >= 0 || window.location.pathname == '/') { 
        // 购物车信息
        $('.Cart__ItemList .CartItem').each(function () {
          $(this).find('.CartItem__Image').attr('src');
          var pic_url=$(this).find('.CartItem__Image').attr('src');
          $('.hurry_buy_popup .cart_product_cen').append('<div class="swiper-slide hurry_buy_slide"><img src="'+ pic_url +'"></div>');
        })
        $('.hurry_buy_popup .cart_num').text($(".Header__Wrapper .cart-link__bubble").text());
      // 获取购物车的产品数量
      // 催购弹窗弹出次数
      if($('.Cart__ItemList .CartItem').length>0){
          if($.cookie("addProductCookieName")){
            add_product_interval = setInterval(function() {
              var now = new Date();
              var addProductTime = new Date(parseInt($.cookie("addProductCookieName")));
              var seconds = (now - addProductTime) / 1000;
              if(seconds>=300){
                popon5();
              }
            }, 1000);
          }else{
            if($.cookie("poupon_num")){
              if($.cookie("poupon_num")==1){
                // 已经弹出过一次过5分钟再弹
                close_popon5_interval = setInterval(function() {
                  var now = new Date();
                  var closePoponTime = new Date(parseInt($.cookie("poupon_close_time")));
                  var seconds = (now - closePoponTime) / 1000;
                  if(seconds>=600){
                    popon5();
                  }
                }, 1000);
              }
            }else{
              popon5();
            }
          }
    
    
      }
      if($('.Cart__ItemList .CartItem').length<=2){
        $('.hurry_buy_popup .cart_product_cen').addClass('cart_product_cen_two');
      }
  }
  // 占位图
  $('img.pic_site').each(function () {
    $(this).attr('src', $(this).attr('data-src'));
  })
  // $('img.pic_site').attr('src', $('img.pic_site').attr('data-src'));
// 导航栏
  $('.Header__MainNav .HorizontalList__Item').each(function () {
    $(this).find('a').each(function () {
      if($(this).find('.Header__LinkSpacer').text()=='🔥Put On and Go Lace Wigs'){
        $(this).css('color','#b61d0f');
      }
    })
    $(this).find('.DropdownMenu').each(function () {
        $(this).find('.Linklist__Item').each(function () {
              if($(this).find('a').text()=='🔥7x5 Bye Bye Knots Wigs '||$(this).find('a').text()=='🔥13×4 Pre-Everything Wigs '){
                $(this).find('a').css('color','#b61d0f');
              }
        })
   
  
    })
  })
  // 导航栏
  $('.Header__MainNav .MegaMenu__Item .Linklist__Item').each(function () {
    if($(this).find('a').text()=='13x4-glueless-lace-front-wig'||$(this).find('a').text()=='wear-go-3-seconds-install'){
      $(this).find('a').css('color','#b61d0f');
    }
  })
  if($('.Header__MainNav .MegaMenu__Item .Linklist__Item a').text()=='wear-go-3-seconds-install'){
    $(this).style('css','#b61d0f');
  }

  if(jQuery(window).width()<768){
    $('.best_sale').find('.ProductList .Grid__Cell').eq(0).addClass('top_product');
    $('.best_sale').find('.ProductList .Grid__Cell').eq(0).find('.colllection_buyout').removeClass('none').find('.buyout').addClass('none');
    $('.best_sale').find('.ProductList .Grid__Cell').eq(0).find('.colllection_buyout').append('<ul class="tips"><li>· 7x5 Deep Part</li><li>· Bye Bye Knots</li><li>· Zig Zag Pre-Cut Lace</li></ul>')
    $('.best_sale').find('.ProductList .Grid__Cell').eq(0).find('.ProductItem__ImageWrapper').append('<div class="kie_pick">Put on and go</div>');
    $('.best_sale').find('.ProductList .Grid__Cell').eq(0).find('.primeBadges').remove();
    // $('.best_sale').find('.ProductList .Grid__Cell').eq(0).find('.ProductItem__ImageWrapper').append('<img src="https://cdn.shopify.com/s/files/1/1720/3725/files/Group_270988963.png?v=1706595774" class="top1">')
  }

  if(jQuery(window).width()>769){
       // 产品列表图片滑动的移入移出
          jQuery(".ProductList .Carousel__Cell .ProductItem").each(function () {
            mouse_item_pic($(this));
          })
         jQuery(".ProductList .Grid__Cell .ProductItem").each(function () {
            mouse_item_pic($(this));
         })

  } 

  // 单个图片放到产品中
  
      jQuery(".ProductList .Grid__Cell .ProductItem").each(function () {
        // 徽章的长度判断    
        updateDisplay($(this)); // 初始化检查
    
        // 监听窗口大小变化
        $(window).resize(updateDisplay);

        // 点击右边按钮给图片添加src值
        $(this).find('.swiper-button-next').click(function name(params) {
          $(this).parent().find('img:eq(1)').attr('src',$(this).parent().find('img:eq(1)').attr('data-original'));
          $(this).parent().find('img:eq(2)').attr('src',$(this).parent().find('img:eq(2)').attr('data-original'));
        })
         product_big_pic($(this));
      })

        function updateDisplay(list) {
            // 转换为 jQuery 对象
            var $list = $(list);
          if($list.length){
            if($list.find('.huizhang_out').length>=1){
              const containerWidth = $list.find('.huizhang_out').width();
              let totalWidth = 0;
              let visibleCount = 0;
              $list.find('.huizhang_out .huizhang').each(function() {
                  totalWidth += $(this).outerWidth(true); // 计算每个 span 的宽度
                  if (totalWidth <= containerWidth) {
                      visibleCount++; // 增加可见计数
                  } else {
                      return false; // 退出循环
                  }
              });
      
              // 根据可见计数设置显示状态
              $list.find('.huizhang_out .huizhang').hide(); // 先隐藏所有
              $list.find('.huizhang_out .huizhang').slice(0, visibleCount).show(); // 只显示可见的
            }
          }

 
        }


    
      function product_big_pic(item){
        if(item.attr("data-product-id")=='6958950252678'||item.attr("data-product-id")=='6958955659398'||item.attr("data-product-id")=='6958957625478'||
        item.attr("data-product-id")=='6958960443526'||item.attr("data-product-id")=='6958962344070'||item.attr("data-product-id")=='6958965915782'){
          item.find('.ProductItem__Info').remove();
          if(jQuery(window).width()>768){
            item.find('img').css('height','87%');
            item.parent().css('margin-bottom','0');
          }
        }
        if( item.attr("data-product-id")=='6958950252678'){
          item.find('a').attr('href', '/collections/bleached-knots-wig');
        }
        if( item.attr("data-product-id")=='6958955659398'){
          item.find('a').attr('href', '/collections/50-off-flash-sale');
        }
        if( item.attr("data-product-id")=='6958957625478'){
          item.find('a').attr('href', '/collections/60-off-clearance');
        }
        if( item.attr("data-product-id")=='6958960443526'){
          item.find('a').attr('href', '/collections/100-off-full-101');
        }
        if( item.attr("data-product-id")=='6958962344070'){
          item.find('a').attr('href', '/collections/99-flash-sale-collection');
        }
        if( item.attr("data-product-id")=='6958965915782'){
          item.find('a').attr('href', '/pages/ways-to-redeem');
        }
     
      }
      jQuery(".swiper-container .ProductItem").each(function () {
        // 徽章的长度判断    
        updateDisplay($(this)); // 初始化检查
        // 监听窗口大小变化
        $(window).resize(updateDisplay);
      })
      // 单个图片放到产品中结束
     jQuery(".ProductList .Carousel__Cell .ProductItem").each(function () {
      // 徽章的长度判断    
      updateDisplay($(this)); // 初始化检查
      // 监听窗口大小变化
      $(window).resize(updateDisplay);
      product_big_pic($(this));
     })
     jQuery(".ProductList .Grid__Cell .ProductItem").each(function () {
      product_big_pic($(this));
     })
   
  if(window.location.pathname=="/collections/wigs"){
     const url = window.location;
     const arr = url.pathname.split('/');
     arr.pop();
     arr.push('wig');
     const newUrl = url.origin + arr.join('/') + url.search;
     history.pushState('', '', newUrl); // 不刷新页面
  }
  // 搜索页面
  if(jQuery(window).width()>768){
      // 搜索推荐产品
      var mySwiper = new Swiper('.search_recommended_product_con',{
            pagination: '.swiper-pagination',
            slidesPerView: 4,
            paginationClickable: true,
            spaceBetween: 30,
            nextButton: '.swiper-button_next_search_recommended_product_cen',
            prevButton: '.swiper-button_prev_search_recommended_product_cen',
    })

  }
    // menu折叠
    $('.side_nav_right .two_nav_pic_first_list').each(function(){
      $(this).find('.m_menu_right_third .iconfont').click(function(){
        if($(this).hasClass('icon-up')){
          $(this).addClass('icon-down').removeClass('icon-up');
          $(this).parent().siblings('.grandchild').css('height','0');
          $(this).parent().siblings('.grandchild').css('overflow-y','hidden');
        }else{
          $(this).addClass('icon-up').removeClass('icon-down');
          $(this).parent().siblings('.grandchild').css('height','auto');
          $(this).parent().siblings('.grandchild').css('overflow-y','auto');
        }
      })
      $(this).find('.m_menu_right_third .view_btn').click(function(){
        if($(this).hasClass('view-more_out')){
          console.log('点击展开');
          $(this).siblings('.third_menu_list').removeClass('hidden');
          $(this).appendTo($(this).parent());
          $(this).addClass('view-less_out').removeClass('view-more_out').find('a').text('View Less');
        }else{
          console.log('点击折叠');
          $(this).siblings('.third_menu_list').addClass('hidden');
          $(this).addClass('view-more_out').removeClass('view-less_out').find('a').text('View More');
          const $button = $(this); // 当前点击的按钮
          const $ul = $(this).parent(); // 获取目标 ul
          const $eighthLi = $ul.children("li").eq(7); // 获取 ul 的第八个 li (索引从 0 开始)
          // 将按钮移动到第八个 li 的后面
          $eighthLi.after($button);
          // 如果需要滚动视图到第八个 li 的位置（可选）
          $eighthLi[0].scrollIntoView({ behavior: "smooth", block: "center" });
        }
        // $(this).click(function(){
        //   console.log('点击折叠');
        //   $(this).siblings('.third_menu_list').addClass('hidden');
        //   $(this).addClass('view-more_out').removeClass('view-less_out').find(a).text('View More');
        // })
        // $(this).parent().append('<li class="two_nav_item view-less_out"><a href="javascript:;" class="view-more-btn">View Less</a></li>');
        // $(this).parent().find('.view-less_out').click(function(){
        //   console.log('点击合并',$(this));
        //   $(this).siblings('.third_menu_list').addClass('hidden');
        //   // const firstThirdMenuList = $(this).siblings('.third_menu_list').first();
        //   // if (firstThirdMenuList.length) {
        //   //   $('<li class="two_nav_item view-more_out"><a href="javascript:;" class="view-more-btn">View More</a></li>').insertBefore(firstThirdMenuList);
        //   // }
        //   $(this).remove();
        //   // $(this).parent().append('<li class="two_nav_item view-more_out"><a href="javascript:;" class="view-more-btn">View More</a></li>');
        // })
      })
      // $(this).parent().find('.m_menu_right_third .view-less_out').click(function(){
      //   console.log('点击合并');
      //   $(this).siblings('.third_menu_list').addClass('hidden');
      //   $(this).remove();
      //   // $(this).parent().append('<li class="two_nav_item view-more_out"><a href="javascript:;" class="view-more-btn">View Less</a></li>');
      // })

    })
  // 分类页折叠
  if(jQuery(window).width()<769){
      // $('#read-more').append('<span class="icon-down iconfont"></span>');
      $('.collection_foot #read-more span').click(function() {
        if($(this).hasClass('icon-down')){
          console.log('点击展开');
          $('.collection_foot_description_con ul li:first-child .collection_foot_description_con_right img').css('height','auto');
          $('.collection_foot_description_con ul li:not(:first-child)').css('display', 'block');
          $('#read-more span').addClass('icon-up').removeClass('icon-down');
        }else{
          console.log('点击折叠');
          $('.collection_foot_description_con ul li:first-child .collection_foot_description_con_right img').css('height','195px');
          $('.collection_foot_description_con ul li:not(:first-child)').css('display', 'none');
          $('.collection_foot #read-more span').addClass('icon-down').removeClass('icon-up');
        }
        return false;
      });
    //部分分类页不折叠
      if( window.location.pathname=="/collections/60-off-clearance" || window.location.pathname=="/collections/99-winter-trends-flash-sale-zone"||window.location.pathname=="/collections/klaiyi-super-saving-wednesday-sale"){
      $('.SectionHeader__Description').css('height','auto');
        $('.collection_foot #read-more').css('display','none');
     }
  
  }

 

        // 公共直接购买
        var productId ='';
        jQuery(".buy_icon").each(function(index,ele){
          jQuery(this).on('click', function () {
            productId = jQuery(this).attr('data-id');
            cart_api_buy(productId);
          })
        })
        function cart_api_buy(sku_id){
              quantity = $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value');
              console.log('获取的加购数量',quantity);
                fetch('/cart/add.js', {
                  method:'POST',
                  headers: {'Content-Type':'application/json'},
                  body:JSON.stringify({
                    id: productId,quantity: quantity
                  })
                }).then(function(response) {
                  // 处理响应
                  if(response.ok) {
                    $('.teast_popup p').text('The item has been added to cart');
                    $(".teast_popup").removeClass('none');
                    $(".teast_popup").delay(5000).fadeOut("slow");
                      var checkout_href="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart');
                      $('.quick_shop_main .quick_shop_button_buy').attr('href',checkout_href);
                     location.href ="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart');
                   
                  }else{
                    $('.teast_popup p').text('Failed to add shopping cart');
                    $(".teast_popup").removeClass('none');
                    $(".teast_popup").delay(3000).fadeOut("slow");
                  }
                })
                .catch(function(error) {
                  console.error('Failed to add shopping cart：', error);
                });
        }
      if(window.location.pathname=="/cart"){
        if($('.EmptyState').length>0){
          clickTimer = setTimeout(function() {
               quick_addCart();
          }, 1000);
        }else{
          quick_addCart();
        }
      }else{
          quick_addCart();
      }

  })
  function mouse_item_pic(item) {
      item.find('.new_ProductItem_pic_wai').mouseenter(function(){
        item.find('.swiper-button-black').css('display','block');
      })
      item.find('.new_ProductItem_pic_wai').mouseleave(function(){
        item.find('.swiper-button-black').css('display','none');
        $('.quick_shop').find('.swiper-button-black').css('display','block');
      })
  }
  var open_popon5_interval;
  function popon5(){
    $.removeCookie('addProductCookieName');
    $('.hurry_buy_popup').css('visibility','unset');
    jQuery('.hurry_buy_popup .window-cover').show();
    jQuery('.hurry_buy_popup .pop_main_cen').show();
    jQuery('.hurry_buy_popup .pop_main_cen .pop_con').css({'top':0,'opacity':0})
    jQuery('.hurry_buy_popup .pop_main_cen .pop_con').animate({'top':'50%','opacity':1})
    clearInterval(close_popon5_interval);
    clearInterval(add_product_interval);
    
    poupon_num = parseInt(poupon_num)+1;
    $.cookie("poupon_num",poupon_num,{ expires:t, path: '/' });  //第二天0点失效
    // 弹窗图片轮播
    if($('.Cart__ItemList .CartItem').length>2){
      var mySwiper = new Swiper('.hurry_buy_popup .cart_product',{ 
        pagination: '.hurry_buy_popup_swiper-pagination',
        slidesPerView: 2.2,
        paginationClickable: true,
        spaceBetween: 11,
      })
    }
    var flash_sale_price_all = 0;
    $(".Cart__ItemList .CartItem").each(function (index) {
      if($(this).find('.CartItem__Title a').text().indexOf("Flash Sale") > 0 ) { 
        var flash_sale_price = $(this).find('.quantity_pc .CartItem__Price .money').text();
        var flash_sale_price_new = flash_sale_price.replace("$", ""); // 去掉逗号
        flash_sale_price_all +=  parseFloat(flash_sale_price_new)*parseFloat($(this).find('.QuantitySelector__CurrentQuantity').val());
      }

      if($(this).find('.CartItem__Title a').text().indexOf("Free Gifts") > 0 ) {
        var free_gift_price = $(this).find('.quantity_pc .CartItem__Price .money').text();
        var free_gift_price_new = 0; // 去掉逗号
        flash_sale_price_all += free_gift_price_new;
      }
    })
    var Remain_total_price=(afterpay_cart_total_price/100-flash_sale_price_all).toFixed(2);
    if(Remain_total_price>479){
      $('.discount_num').text('120');
      $('.code_num .number').text('New120');
      $('.total_num').text()-120
      $('.hurry_buy_popup .total_num').text(((afterpay_cart_total_price/100)-120).toFixed(2));
      $('.hurry_buy_popup .pop_detail_top').css('display','block');
    }else if(Remain_total_price>349){
      $('.discount_num').text('80');
      $('.code_num .number').text('New80');
      $('.hurry_buy_popup .total_num').text(((afterpay_cart_total_price/100)-80).toFixed(2));
      $('.hurry_buy_popup .pop_detail_top').css('display','block');
    }else if(Remain_total_price>249){
      $('.discount_num').text('50');
      $('.code_num .number').text('New50');
      $('.hurry_buy_popup .total_num').text(((afterpay_cart_total_price/100)-50).toFixed(2));
      $('.hurry_buy_popup .pop_detail_top').css('display','block');
    }else if(Remain_total_price>159){
      $('.discount_num').text('30');
      $('.code_num .number').text('New30');
      $('.hurry_buy_popup .total_num').text(((afterpay_cart_total_price/100)-30).toFixed(2));
      $('.hurry_buy_popup .pop_detail_top').css('display','block');
    }else if(Remain_total_price>119){
      $('.discount_num').text('20');
      $('.code_num .number').text('New20');
      $('.hurry_buy_popup .total_num').text(((afterpay_cart_total_price/100)-20).toFixed(2));
      $('.hurry_buy_popup .pop_detail_top').css('display','block');
    
    }else{
      $('.hurry_buy_popup .pop_detail_top').css('display','none');
      $('.hurry_buy_popup .cart_title').text('Your Selection Will Be Out Of Stock Soon!');
      $('.hurry_buy_popup .cart_title').css('width','80%');
      $('.hurry_buy_popup .total_num').text(afterpay_cart_total_price/100);
    }


    // 打开弹窗开始计时
    var countdownTime = 10 * 60 * 1000; // 10分钟
        // 每秒更新一次倒计时
         open_popon5_interval = setInterval(updateTimer, 1000);
        function updateTimer() {
          var timeLeft = countdownTime;
       
          // 获取剩余时间
          var hours = Math.floor(timeLeft / 3600000);
          var minutes = Math.floor((timeLeft - (hours * 3600000)) / 60000);
          var seconds = Math.floor((timeLeft % 60000) / 1000);
       
          // 格式化时间显示
          hours = hours < 10 ? "0" + hours : hours;
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
       
          // 显示剩余时间
          // 分
          var str_minutes=minutes + ''; 
          var s_minutes=str_minutes.substr(0, 1);
          jQuery('.ten_end_minute_one').text(s_minutes);
          jQuery('.ten_end_minute_two').text(str_minutes.charAt(str_minutes.length-1));
          // 秒
          var str_seconds=seconds + ''; 
          var s_seconds=str_seconds.substr(0, 1);
          jQuery('.ten_end_second_one').text(s_seconds);
          jQuery('.ten_end_second_two').text(str_seconds.charAt(str_seconds.length-1));
          // $("#timer").text(minutes + ":" + seconds);
       
          // 如果时间到了则清除计时器
          if (timeLeft <= 0) {
            clearInterval(open_popon5_interval);
            close_popon5();//打开10分钟之后自动关闭
            // $("#timer").text("倒计时结束！");
          }
       
          // 减少时间
          countdownTime -= 1000;
        }
        $.cookie("poupon_open_time",new Date().getTime(),{ expires:t, path: '/' }); 
        $('.hurry_buy_popup .pop_detail_bottom').click(function() {
          // 当check now被点击时，同时触发购物按钮的点击事件
          $('.Cart .Drawer__Footer .Cart__Checkout').trigger('click');
        });
  }

 function close_popon5(){
    clearInterval(open_popon5_interval);
    $('.hurry_buy_popup').css('visibility','hidden');
    jQuery('.hurry_buy_popup .window-cover').hide();
    jQuery('.hurry_buy_popup .pop_main_cen').hide();
    jQuery('.hurry_buy_popup .pop_main_cen .pop_con').animate({'top':'50%','opacity':1})
    jQuery('.hurry_buy_popup .pop_main_cen .pop_con').css({'top':0,'opacity':0})
    if(parseInt($.cookie("poupon_num")) == 1){
      $.cookie("poupon_close_time",new Date().getTime(),{ expires:t, path: '/' }); 
      close_popon5_interval=setInterval(function() {
        var now = new Date();
        var addProductTime = new Date(parseInt($.cookie("poupon_close_time")));
        var seconds = (now - addProductTime) / 1000;
        if(seconds>=300){
          popon5();
        }
      }, 1000);
    }
 }
//  进行关闭弹窗定时器
//  function countdown() {

// }
 $('.hurry_buy_popup .window-cover_con-close').click(function(){
  close_popon5();
 })
// 点击购买按钮生成快速加购弹窗
function quick_addCart() {
  console.log('快速加购');
    $('.ProductListWrapper .ProductItem').each(function(){
        $('.quick_shop form .quick-shop-cen-option').html('');
        jQuery(this).find('.ProductItem__PriceList .addCart_icon').off("click").on("click",function(){
          console.log('点击快速加购按钮');
          let $this = $(this);
          if ($this.hasClass("disabled")) return; // 已禁用，不执行
      
          $this.addClass("disabled"); // 禁用点击
          setTimeout(() => {
              $this.removeClass("disabled"); // 2秒后恢复
          }, 5000);

          if ($('.quick_shop_main').is(':visible')) {
            console.log('quick_shop_main 是显示的');
            $this.addClass("disabled"); // 禁用点击
          } else {
              console.log('quick_shop_main 是隐藏的（display: none 或 visibility: hidden）',$('.quick_shop_main').css('display'));
              quick_icon_click(jQuery(this),jQuery(this).parent().siblings().find('a').attr('href'));
    
          }
          

        })

    })
  if(clickTimer){
      clearTimeout(clickTimer);
  }

}
var option1= '';
var option2= '';
var option3= '';
var productId = '';
var skuId = '';
var sku_word = '';
var quantity = 1;
window.quick_icon_click = function(item,new_url){
  updatePopupHeight();
  // 判断new_url是否包含查询字符串
  var urlWithoutQuery = new_url || ''; // 确保new_url不为空
  if (urlWithoutQuery) {
    // 移除查询字符串
    urlWithoutQuery = urlWithoutQuery.replace(/\?.*$/, '');
  }
  // 获取当前产品的内容
  var now_index=0;
  // 确保urlWithoutQuery不为空后再发送请求
  if (urlWithoutQuery) {
    $.ajax({
      url: "https://www.klaiyihair.com" + urlWithoutQuery + ".js",
      type: 'GET', // 指定请求类型
      dataType: 'json', // 指定返回数据类型
      success: function(response) {
          // 请求成功时的回调函数
          var new_data_json=response;
          var product_data_json=response;
          console.log('接口返回的数据',product_data_json);
          var additionalCheckoutButtons = '{{ content_for_additional_checkout_buttons | paypal }}';
          console.log('获取产品接口里面的返回内容',product_data_json,item.parent().parent().parent().parent().html());
          $('.quick_shop form .quick-shop-cen-option').html('');
          $('.quick_shop form .quick-shop-cen-option').append(`
              <div class="ProductItem__Wrapper" data-id="" sku-id="" sku-word="">
                  <div class="ProductItem_pic_title">
                    <a href="/${urlWithoutQuery}" class="ProductItem__ImageWrapper">
                      <div class="new_ProductItem_pic_wai swiper-container swiper-container-horizontal">
                        <div class="swiper-button-prev swiper-button-black swiper-button_prev_new_ProductItem_pic swiper-button-disabled" style="display: none;"><span class="iconfont icon-arrow_left"></span></div>
                        <div class="new_ProductItem_pic_all swiper-wrapper">
                        </div>
                        <div class="swiper-button-next swiper-button-black swiper-button_next_new_ProductItem_pic" style="display: none;"><span class="iconfont icon-arrow_right"></span></div>
                      </div>
                      <span class="product_xinzheng_discount none"></span>
                      <span class="none discount_type"></span>
                    </a>
                  </div>
                  <div class="ProductItem__Info ProductItem__Info--left">
                    <div class="ProductItem__Title Heading">
                      <a href="/${urlWithoutQuery}">
                      ${item,item.parent().attr('data-badge')? `
                        <div class="huizhang_out"></div>
                      ` : ''}
                        <span class="ptit">${product_data_json.title}</span>
                      </a>
                    </div>
                    <div class="ProductItem__PriceList  Heading">
                      <span class="ProductItem__Price Price Price--highlight Text--subdued"><span class="money">$${(product_data_json.price / 100).toFixed(2)} </span></span>
                      ${product_data_json.compare_at_price && product_data_json.compare_at_price > 0 ? `
                        <div class="ProductInfo_title_price_old">
                          <span class="ProductItem__Price Price Price--compareAt Text--subdued">
                            <span class="money">$${(product_data_json.compare_at_price / 100).toFixed(2)} </span>
                          </span>
                        </div>
                      ` : ''}
                    </div>
                  </div>
              </div>
          `);
          if(item.parent().siblings().hasClass('buyout_out')){
            console.log('当前产品有一口价',item.parent().siblings('.buyout_out'));
            $('.quick-shop-cen .ProductItem__PriceList').after(item.parent().siblings('.buyout_out'));
            if($('.quick-shop-cen .buyout_out').hasClass('none')){
              $('.quick-shop-cen .buyout_out').removeClass('none');
            }
          }

          if(item.parent().attr('data-coupon_rule')){
            var discountType = item.parent().attr('data-coupon_rule');  // 从 DOM 中获取属性值
            
            // 将 Ruby 风格的字符串转换为标准 JSON 格式
            var discountTypeData = discountType.replace(/=>/g, ':').replace(/nil/g, 'null');
            
            // 2. 解析 JSON 字符串
            try {
                var discountTypeBadges = JSON.parse(discountTypeData);
                $('.quick-shop-cen .discount_type').text(discountTypeBadges.discount_type);
                $('.quick-shop-cen .product_xinzheng_discount').text(discountTypeBadges.discount);
            } catch (e) {
                console.error('无法解析 data-badge 内容:', e);
            }
          }else{
            console.log('获取折扣',item.closest(".ProductItem__Wrapper").find('.discount_type'));
            $('.quick-shop-cen .discount_type').text(item.closest(".ProductItem__Wrapper").find('.discount_type').text());
            $('.quick-shop-cen .product_xinzheng_discount').text(item.closest(".ProductItem__Wrapper").find('.product_xinzheng_discount').text());
          }
           // 1. 获取 data-badge 的内容
           console.log('获取点击的内容',item,item.parent().attr('data-coupon_rule'));
            // 1. 获取 data-badge 的内容并转换为有效的 JSON 格式
            if(item.parent().attr('data-badge')){
              var badgeDataString = item.parent().attr('data-badge');  // 从 DOM 中获取属性值
              
              // 将 Ruby 风格的字符串转换为标准 JSON 格式
              var badgeData = badgeDataString.replace(/=>/g, ':').replace(/nil/g, 'null');
              
              // 2. 解析 JSON 字符串
              try {
                  var badges = JSON.parse(badgeData);
                  
                  // 3. 遍历 badges 数组，生成并插入 HTML
                  badges.slice(0, 2).forEach(badge => { // 只取前两个徽章
                    let badgeHTML = `<span style="color:${badge.text_color}; background:${badge.background_style}; border: 1px solid ${badge.table_color}" class="huizhang">${badge.name}</span>`;
                    
                    $('.huizhang_out').append(badgeHTML);
                  });
              } catch (e) {
                  console.error('无法解析 data-badge 内容:', e);
              }
            }else{
              // 获取 .huizhang_out
              let badgeContainer = item.closest(".ProductItem__Wrapper").find('.huizhang_out');

              // 确保找到元素
              if (badgeContainer.length) {
                  let badges = badgeContainer.find('.huizhang'); // 获取所有徽章
                  badges.each(function (index) {
                      if (index >= 2) {
                          $(this).remove(); // 删除超过2个的徽章
                      }
                  });

                  // 插入到指定位置
                  $('.quick_shop_main .ProductItem__Title a .ptit').before(badgeContainer);
              }
            }
          $('.quick_shop form .new_ProductItem_pic_all').html('');
          if(jQuery(window).width()>=769){
            var quick_shop_small_pic=$('<div class="product_thumbnail"><i class="iconfont icon-up newicon_up"></i><div class="quick_shop_slideshowNav_out"><div class="quick_shop_slideshowNav"></div></div><i class="iconfont icon-down newicon_down"></i></div>');
            $('.quick_shop .ProductItem__ImageWrapper').before(quick_shop_small_pic);
          }
          $.each(new_data_json.images, function(i, picitem) {
            // 动态添加 Swiper slides
            $('.quick_shop form .new_ProductItem_pic_all').append(`
              <img class="ProductItem__Image Image--lazyLoad Image--fadeIn new_ProductItem_pic_list swiper-slide" 
                  src="${picitem}" alt="Product Image" data-index="${i}">
            `);
          
            // 添加小图导航
            $('.quick_shop_slideshowNav').append(`
              <img class="quick_shop_smallpic_list" src="${picitem}" alt="Product Image" data-index="${i}">
            `);
          });
            $('.quick_shop .window-cover').css('display','block');
            $('.quick_shop_main').css('display','block');
            $('.quick_shop_main').css('opacity','1');

            $('html').css('overflow-y','hidden');
            scrollTop = $(window).scrollTop();
            $('body').attr('data-overflow-top',scrollTop);
            console.log('当前滚动高度:', scrollTop);
            $('body').css({
                'overflow': 'hidden',
                'position': 'fixed',
                'top': '-' + scrollTop + 'px',
                'left': '0',
                'right': '0',
                'bottom': '0'
            });
    $('.quick_shop .quick_shop_ProductForm__Option').removeClass('none');
    $('.quick_shop form').attr('data-id',item.parent().parent().parent().attr('data-id'));
    $('.quick_shop form').attr('sku-id',item.parent().parent().parent().attr('sku-id'));
    $('.quick_shop form').attr('sku-word',item.parent().parent().parent().attr('sku-word'));
    $('.quick_shop form .ProductItem__Info').append('<div class="ProductItem__ColorSwatchList quick_shop_ProductForm__Option"></div>');
    $('.quick_shop form .ProductItem__Info').append('<div class="quick_shop_bottom"></div>')
    $('.quick_shop form .shopcar_m_title_price_old').append('<span class="product_detail_save"></span>');
    $('.quick_shop form .ProductItem__Info .ProductInfo_title_price_old').append('<span class="product_detail_save"></span>');


      // 弹窗图片滑动
      if(jQuery(window).width()>=769){
        $('.quick_shop_bottom').html($('.quick_shop .quick-payment-out .quick_payment'));
        $('.quick_shop .quick-payment-out .quick_payment').remove();
        // 主图滑动
        quick_shop_swiper = new Swiper('.quick_shop_main .new_ProductItem_pic_wai',{
                slidesPerView: 1,
                paginationClickable: true,
                spaceBetween: 5,
                nextButton: '.swiper-button_next_new_ProductItem_pic',
                prevButton: '.swiper-button_prev_new_ProductItem_pic',
        })
        console.log('点击获取内容aaa',quick_shop_swiper);
      }
      if(jQuery(window).width()<=768){
        if ($('.quick_shop .quick-payment-out .quick_payment').is(':empty')) {
          console.log('元素内容为空');
          $('.quick_shop_bottom').html('<div class="quick_payment"><div class="quick_shop_button"><a class="quick_shop_button_cart" href="javascript:;">add to cart</a><a class="quick_shop_button_buy">Buy Now</a></div></div>')
        } else {
          $('.quick_shop_bottom').html($('.quick_shop .quick-payment-out .quick_payment'));
          $('.quick_shop .quick-payment-out .quick_payment').remove();
        }
      
          // **确保所有 slide 加载完成后，再插入分页元素**
        $('.quick_shop form .new_ProductItem_pic_wai').append(`
        <div class="quick-shop-swiper-pagination-out"><div class="swiper-pagination quick-shop-swiper-pagination"></div></div>
        `);

        $('.quick_shop .shopcar_m_title_price').removeClass('none');
              // 主图滑动
              var new_ProductItem_pic_mySwiper_m = new Swiper('.quick_shop .new_ProductItem_pic_wai',{
                direction: 'horizontal',
                pagination: '.swiper-pagination',
                slidesPerView: 2.7,
                paginationClickable: true,
                spaceBetween: 12,
                on: {
                  slideChange: function () {
                    console.log('轮播滑动开始');
                  }
                },
            })
      }
                  // 获取右侧大图的高度
                  setTimeout(function(){
                    var largeImageHeight = $('.quick_shop .new_ProductItem_pic_wai').height();
                    console.log('获取大图的高度',largeImageHeight);
                            // 设置左侧小图的高度为与大图相同
                    $('.quick_shop .product_thumbnail').height(largeImageHeight);
                    $('.quick_shop .quick_shop_slideshowNav_out').height(largeImageHeight - 42);
      
                    $('.quick_shop_main .quick_shop_slideshowNav img.quick_shop_smallpic_list').each(function(i,list){
                      console.log('序号',i);
                      if(i==0){
                        $(this).addClass('quick_shop_smallpic_active').siblings().removeClass('quick_shop_smallpic_active');
                      }
                      $(this).click(function(e){
                        var index = $(this).attr('data-index');
                        // var index = parseInt($(this).attr('data-index'), 10);
                        var before_index = parseInt($(this).attr('data-index'))-1;
                        var behand_index = parseInt($(this).attr('data-index'))+1;
                        console.log('点击按钮',index,behand_index);
                        if(index<$('.quick_shop_main .quick_shop_slideshowNav img.quick_shop_smallpic_list').length-3){
                          $(this).addClass('quick_shop_smallpic_active').siblings().removeClass('quick_shop_smallpic_active');
                          $('.quick_shop_slideshowNav').css('margin-top','-' + 73*index + 'px');
                          $('.quick_shop .new_ProductItem_pic_all img').filter('[data-index="' + index + '"]').addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
                          $('.quick_shop .new_ProductItem_pic_all img').filter('[data-index="' + before_index + '"]').addClass('swiper-slide-prev').siblings().removeClass('swiper-slide-prev');
                          $('.quick_shop .new_ProductItem_pic_all img').filter('[data-index="' + behand_index + '"]').addClass('swiper-slide-next').siblings().removeClass('swiper-slide-next');
                        if(index != 0){
                          console.log('点击的第几个呢');
                          $('.quick_shop .ProductItem__ImageWrapper .new_ProductItem_pic_wai .swiper-button_prev_new_ProductItem_pic').removeClass('swiper-button-disabled');
                        }
                          // 选择目标元素
                          var target = $('.quick_shop .new_ProductItem_pic_all'); // 修改为你的目标元素选择器
      
                          // 获取当前 transform 值
                          var transformValue = target.css('transform');
                          
                          // 提取 translate3d 的第一个值（X 轴偏移量）
                          var match = transformValue.match(/matrix.*\((.+)\)/);
                          var translateX = 0;
                          // if (match) {
                          //   var values = match[1].split(','); // 将矩阵的值分割
                          //   var translateX = parseFloat(values[4]) || 0; // 获取 X 偏移量
                          // } else {
                          //   var translateX = 0; // 如果没有 transform 值，默认从 0 开始
                          // }
                          var largeImagewidth = $('.quick_shop .new_ProductItem_pic_wai').width() +5;
                          // 修改 X 轴的偏移量（例如增加 307px）
                          var newTranslateX = translateX - largeImagewidth*index; // 这里 -307 可根据需要调整
                          console.log('一个大图的宽度',newTranslateX,largeImagewidth);
                          // 设置新的 transform 值
                          target.css('transform', `translate3d(${newTranslateX}px, 0px, 0px)`);
                        }
                        if(index != $('.quick_shop_main .quick_shop_slideshowNav img.quick_shop_smallpic_list').length){
                          $('.quick_shop .ProductItem__ImageWrapper .new_ProductItem_pic_wai .swiper-button_next_new_ProductItem_pic').removeClass('swiper-button-disabled');
                          // $('.quick_shop .swiper-button-next').removeClass('swiper-button-disabled');
                        }
                          quick_shop_swiper.slideTo(i);
                          // quick_shop_swiper.slideTo(index);
                      })
                    })
                    // 点击侧边的向下按钮
                    $('.quick_shop .newicon_up').click(function(){
                      console.log('点击向上按钮');
                      now_index=parseInt($('.quick_shop_smallpic_active').attr('data-index'))-1;
                      console.log('点击向下按钮',now_index,$('.quick_shop_smallpic_active').attr('data-index'));
                      $('.quick_shop_main .quick_shop_slideshowNav img.quick_shop_smallpic_list').each(function() {
                        if ($(this).attr('data-index') == now_index) {
                          console.log('点击向下滚动');
                          $(this).addClass('quick_shop_smallpic_active').siblings().removeClass('quick_shop_smallpic_active');
                          now_index=$(this).attr('data-index');
                          $('.quick_shop_slideshowNav').css('margin-top','-' + 73*now_index + 'px');
                          quick_shop_swiper.slideTo(now_index);
                        }
                      });
                    })
                    $('.quick_shop .newicon_down').click(function(){
                      now_index=parseInt($('.quick_shop_smallpic_active').attr('data-index'))+1;
                      console.log('点击向下按钮',now_index,$('.quick_shop_smallpic_active').attr('data-index'));
                      $('.quick_shop_main .quick_shop_slideshowNav img.quick_shop_smallpic_list').each(function() {
                        if ($(this).attr('data-index') == now_index) {
                          console.log('点击向下滚动');
                          $(this).addClass('quick_shop_smallpic_active').siblings().removeClass('quick_shop_smallpic_active');
                          now_index=$(this).attr('data-index');
                          $('.quick_shop_slideshowNav').css('margin-top','-' + 73*now_index + 'px');
                          quick_shop_swiper.slideTo(now_index);
                        }
                      });
                    })
                  },1000)
    $('.quick_shop .view_detail').attr('href',$('.quick_shop .ProductItem__Title a').attr('href'));
    var options=[];
    var all_options1={};
    var all_options2={};
    var all_options3={};
    var variant1=[];
    var variant2=[];
    var variant3=[];
    var flag01=true;
    var flag02=true;
    var flag03=true;
    all_options1.title=new_data_json.options[0];
    if(new_data_json.options.length>=2){
        all_options2.title=new_data_json.options[1];
    }
    if(new_data_json.options.length>=3){
        all_options3.title=new_data_json.options[2];
    }


    $.each(new_data_json.variants,function(i,item){
        flag01=true;
        flag02=true;
        flag03=true;
        $.each(variant1,function(j,list_01){
        if(list_01==item.option1){
            flag01=false;
        }
        })
        $.each(variant2,function(j,list_02){
        if(list_02==item.option2){
            flag02=false;
        }
        })
        $.each(variant3,function(j,list_03){
        if(list_03==item.option3){
            flag03=false;
        }
        })
        if(flag01){
        variant1.push(item.option1);
        }
        if(flag02){
        variant2.push(item.option2);
        }
        if(flag03){
        variant3.push(item.option3);
        }
    });

    all_options1.attribute=variant1;
    all_options2.attribute=variant2;
    all_options3.attribute=variant3;
    options.push(all_options1);
    if(new_data_json.options.length>=2){
        options.push(all_options2);
    }
    if(new_data_json.options.length>=3){
        options.push(all_options3);
    }
    var newDiv2='';
    // 遍历总共有几组分类
    $.each(options,function(k,list){
        var newDiv = '<div class="ProductForm_label_name ProductForm__Label_con"><span class="ProductForm__Label">'+list.title.name+'</span></div>';
        $('.quick_shop form .quick_shop_ProductForm__Option').append(newDiv);
        $('.quick_shop form .quick_shop_ProductForm__Option').append('<div class="option_cen"></div>');
        $.each(list.attribute,function(n,attributes_list){
        if(n == 0){
          if($('.quick_shop form').attr('data-id')=='6950963970182'){
            console.log('进入到这个产品',attributes_list);
            if (attributes_list.includes("New 7x5 Drawstring")) {
              console.log("attributes_list 包含 'New 7x5 Drawstring'");
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers">Upgrade</span></div>'
            }else if(attributes_list.includes("7x5 Bye Bye Knots") || attributes_list.includes("20")  || attributes_list.includes("24")){
              if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">@sherika</span></div>'
              }else{
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">@Kie</span></div>'
              }
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7288508612742'){
            if (attributes_list.includes("13x4 Pre everything wig") || attributes_list.includes("20") ) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("24")){
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">@Ameera $195</span></div>'
            }else if(attributes_list.includes("13x4 Pre everything-150%")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">@Ameera</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='6879878611078'){
            if (attributes_list.includes("13x4 Pre everything")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("14")){
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">Model Length</span></div>'
            }else if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">Extra Gifts</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7035831386246'){
            if(attributes_list.includes("180%")||attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">Free Wig</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7017476948102'){
            if (attributes_list.includes("13x4 Pre everything")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("12")){
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">@KIE</span></div>'
            }else if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">Most Natural</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7045879332998'){
            if (attributes_list.includes("7x5-Bye Bye Knots")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("7x5 Bye Bye Knots（Drawstring）")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers">New</span><span class="markers_long ">Free Upgrade</span></div>'
            }else if(attributes_list.includes("20")){
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">Hot Sale</span></div>'
            }else if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">Most Choice</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='6970186203270'){
            if (attributes_list.includes("7x5 Bye Bye Knots 4.0")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("20") || attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">Extra Gifts</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7227657158790'){
            if (attributes_list.includes("5x5 HD Glueless Lace-180%")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers">Hot</span><span class="markers_long">@Jess</span></div>'
            }else if(attributes_list.includes("20")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">@Jess</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7283737886854'){
            if (attributes_list.includes("13x4 Pre-everything Glueless")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">@Dom</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7258963869830'){
            if(attributes_list.includes("180%")||attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">Free Wig</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='6858272931974'){
            if(attributes_list.includes("180%")||attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label><span class="markers_long">Free Wig</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
            }
          }
          else{
            newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small is-active">'+attributes_list+'</label></div>'
          }
          
        }else{
          if($('.quick_shop form').attr('data-id')=='6950963970182'){
            if (attributes_list.includes("New 7x5 Drawstring")) {
              console.log("attributes_list 包含 'New 7x5 Drawstring'");
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers">Upgrade</span></div>'
            }else if(attributes_list.includes("7x5 Bye Bye Knots") || attributes_list.includes("20")  || attributes_list.includes("24")){
              if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">@sherika</span></div>'
              }else{
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">@Kie</span></div>'
              }
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7288508612742'){
            if (attributes_list.includes("13x4 Pre everything wig") || attributes_list.includes("20") ) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("24")){
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">@Ameera $195</span></div>'
            }else if(attributes_list.includes("13x4 Pre everything-150%")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">@Ameera</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='6879878611078'){
            if (attributes_list.includes("13x4 Pre everything")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("14")){
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">Model Length</span></div>'
            }else if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">Extra Gifts</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7035831386246'){
            if(attributes_list.includes("180%")||attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small">'+attributes_list+'</label><span class="markers_long">Free Wig</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7017476948102'){
            if (attributes_list.includes("13x4 Pre everything")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("12")){
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">@KIE</span></div>'
            }else if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">Most Natural</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7045879332998'){
            if (attributes_list.includes("7x5-Bye Bye Knots")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("7x5 Bye Bye Knots（Drawstring）")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers">New</span><span class="markers_long ">Free Upgrade</span></div>'
            }else if(attributes_list.includes("20")){
                newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">Hot Sale</span></div>'
            }else if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">Most Choice</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='6970186203270'){
            if (attributes_list.includes("7x5 Bye Bye Knots 4.0")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("20") || attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">Extra Gifts</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7227657158790'){
            if (attributes_list.includes("5x5 HD Glueless Lace-180%")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers">Hot</span><span class="markers_long">@Jess</span></div>'
            }else if(attributes_list.includes("20")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">@Jess</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7283737886854'){
            if (attributes_list.includes("13x4 Pre-everything Glueless")) {
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers">Hot</span></div>'
            }else if(attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label><span class="markers_long">@Dom</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='7258963869830'){
            if(attributes_list.includes("180%") || attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small">'+attributes_list+'</label><span class="markers_long">Free Wig</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }else if($('.quick_shop form').attr('data-id')=='6858272931974'){
            if(attributes_list.includes("180%")||attributes_list.includes("24")){
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small">'+attributes_list+'</label><span class="markers_long">Free Wig</span></div>'
            }else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small ">'+attributes_list+'</label></div>'
            }
          }
            else{
              newDiv2='<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--small">'+attributes_list+'</label></div>'
            }
        }
        $('.quick_shop form .option_cen:eq('+k+')').append(newDiv2);
        })
    })
    $('.quick_shop form .quick-shop-quantity').children().appendTo(".quick-shop-cen .ProductItem__ColorSwatchList");
    // 快速加购pc端结构更改
    if(jQuery(window).width()>768){
      if (!$('.quick_shop_main .ProductItem_pic_title').hasClass('ProductItem_pic_title-out')) {
        $('.quick_shop_main .ProductItem_pic_title').wrap('<div class="ProductItem_pic_title-out"></div>');
      }
      $('.quick_shop_main .ProductItem_pic_title-out').append('<div class="Seller_Guarantee"><li><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/Delivery.png?v=1714455595" width="24" height="24"><span class="">3-5 Days Delivery</span></li><li><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/Space-Shuttle.png?v=1714455595" width="24" height="24"><span class="">30 Days Free Return</span></li><li><img src="https://cdn.shopify.com/s/files/1/1720/3725/files/Wallet.png?v=1714455595" width="24" height="24"><span class="">Free Shipping</span></li></div>');
    }
    // 快速加购m端结构更改
    if(jQuery(window).width()<768){
        $('.quick_shop_main .ProductItem_pic_title').append('<div class="shopcar_m_title_price"><h2 class="ProductItem__Title Heading"></h2></div>');
        $('.quick_shop_main .shopcar_m_title_price .ProductItem__Title').append($('.quick_shop_main .ProductItem__Info .ProductItem__Title').html());
        $('.shopcar_m_title_price').append('<div class="ProductItem__PriceList Heading"></div>');
        $('.shopcar_m_title_price .ProductItem__PriceList').append($('.quick_shop_main .ProductItem__Info .ProductItem__PriceList').html());
        $('.shopcar_m_title_price').append($('.quick_shop_main .ProductItem__Info .buyout_out').clone());

        console.log('点击之后的一口价内容2',$(".quick_shop_main .shopcar_m_title_price .buyout_out"));
        $('.quick_shop_main .ProductItem_pic_title .ProductItem__ImageWrapper').attr('href',"javascript:;");
        $('.quick_shop_main .ProductItem__Title a').attr('href',"javascript:;");
        
              // $(".quick_shop_main .shopcar_m_title_price .buyout_out").clone().appendTo(".quick_shop form .quick_shop_bottom .buy_btn_save");
    
        $('.quick_shop form .quick_shop_bottom').prepend('<div class="buy_btn_save"><span class="total_word">Total:</span><span class="ProductInfo_title_price_now"></span><span class="ProductInfo_title_price_old"></span></div>');
        $(".quick_shop_main .shopcar_m_title_price .buyout_out").clone().appendTo(".quick_shop form .quick_shop_bottom .buy_btn_save");
        setTimeout(() => {
        //   var viewportHeight = (window.visualViewport && window.visualViewport.height)  
        //   ? window.visualViewport.height 
        //   : window.innerHeight; 
        //   alert('高度: ' + viewportHeight);
        //   if(jQuery(window).width()<376){
        //     var quickShopOptionHeight = 
        //     viewportHeight * 0.55  // 86vh 转换成像素
        //     - 44  // 44px
        //     - $('.ProductItem_pic_title').outerHeight(true)  // 获取 `.ProductItem_pic_title` 的高度（包括外边距）
        //     - $('.quick_shop_bottom').outerHeight(true);  // 获取 `.quick_shop_bottom` 的高度（包括外边距）
        //   }
        //   if(jQuery(window).width()>389){
        //     var quickShopOptionHeight = 
        //     viewportHeight * 0.56  // 86vh 转换成像素
        //     - $('.ProductItem_pic_title').outerHeight(true)  // 获取 `.ProductItem_pic_title` 的高度（包括外边距）
        //     - $('.quick_shop_bottom').outerHeight(true);  // 获取 `.quick_shop_bottom` 的高度（包括外边距）
        //   }
        //   if(jQuery(window).width()>392){
        //     var quickShopOptionHeight = 
        //     viewportHeight * 0.56 // 86vh 转换成像素
        //     - $('.ProductItem_pic_title').outerHeight(true)  // 获取 `.ProductItem_pic_title` 的高度（包括外边距）
        //     - $('.quick_shop_bottom').outerHeight(true);  // 获取 `.quick_shop_bottom` 的高度（包括外边距）
        // // 获取 `.quick_shop_bottom` 的高度（包括外边距）
        //   }
        //   console.log('快速加购option的高度为',quickShopOptionHeight);
        //   $('.quick_shop .ProductItem__ColorSwatchList').css('max-height',quickShopOptionHeight);
          var newViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
          console.log('视口高度:', newViewportHeight);
              // 只使用 visualViewport 获取高度，避免地址栏的影响
          let currentHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
          var picTitleHeight = $('.quick-shop-cen .ProductItem_pic_title').outerHeight(true) || 0;
          var quickShopBottomHeight = $('.quick_shop_bottom').outerHeight(true) || 0;

          console.log('最小屏幕',jQuery(window).width());
          if(url.indexOf("/products/") >= 0 || url.indexOf("/collections/") >= 0) {
            console.log('详情页点击的加购按钮'); 
            if($('.quick_shop .buyout_out').length<=0){
              console.log('没有一口价');
              var quickShopOptionHeight = $('.quick_shop_main form').outerHeight(true) - picTitleHeight - quickShopBottomHeight - 120;
            }else{
              var quickShopOptionHeight = $('.quick_shop_main form').outerHeight(true) - picTitleHeight - quickShopBottomHeight - 150;
            }
          }else{
            console.log('其他页面点击的加购按钮'); 
            if($('.quick_shop .buyout_out').length<=0){
              console.log('没有一口价');
              var quickShopOptionHeight = $('.quick_shop_main form').outerHeight(true) - picTitleHeight - quickShopBottomHeight - 100;
            }else{
              var quickShopOptionHeight = $('.quick_shop_main form').outerHeight(true) - picTitleHeight - quickShopBottomHeight - 130;
            }
          }
    
          console.log('快速加购 option 的高度为:', $('.quick_shop_main form').outerHeight(true),picTitleHeight,quickShopBottomHeight,quickShopOptionHeight);
          $('.quick_shop .ProductItem__ColorSwatchList').css('max-height',$('.quick_shop_main form').outerHeight(true) - picTitleHeight - quickShopBottomHeight - 50);
        }, 100);



      // 判断图片滑动的方向
      let startX, startY, distX, distY, threshold = 150; // 定义一个阈值来判断是否触发了滑动
      $('.quick-shop-cen-option .new_ProductItem_pic_wai .new_ProductItem_pic_list').each(function(index){
          $(this).on('touchstart', function(e) {
            startX = e.originalEvent.touches[0].pageX;
            startY = e.originalEvent.touches[0].pageY;
            // 记录开始触摸的位置
              console.log('记录开始触摸的位置',$(this).attr('data-index'));
          });
          $(this).on('touchmove', function(e) {
            e.preventDefault();
            var endX, endY, direction;
            endX = e.originalEvent.touches[0].pageX;
            endY = e.originalEvent.touches[0].pageY;
            // 计算水平和垂直方向的位移
            var deltaX = endX - startX;
            var deltaY = endY - startY;
          
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                // 水平方向移动
                if (deltaX > 0) {
                    direction = 'right';
                    console.log('往又有移动',$(this).attr('data-index'),left_width);
                    if($(this).attr('data-index')>1 && $(this).attr('data-index')<$('.quick-shop-cen-option .new_ProductItem_pic_wai .new_ProductItem_pic_list').length-3){
                      var pic_index=$(this).attr('data-index');
                      left_width="-" +(24*Number(pic_index-3));
                      console.log('移动位置',left_width);
                      $('.quick-shop-swiper-pagination-out .quick-shop-swiper-pagination').css('margin-left',left_width+'px');

                    }
                } else {
                    direction = 'left';
                    console.log('往左左移动');
                    console.log('开始移动',$(this).attr('data-index'),left_width);
                    if($(this).attr('data-index')>1 && $(this).attr('data-index')<$('.quick-shop-cen-option .new_ProductItem_pic_wai .new_ProductItem_pic_list').length-3){
                      var pic_index=$(this).attr('data-index');
                      left_width="-" +(24*Number(pic_index-2));
                      console.log('移动位置',left_width);
                      $('.quick-shop-swiper-pagination-out .quick-shop-swiper-pagination').css('margin-left',left_width+'px');
                    }
                }
            } else {
                // 垂直方向移动
                if (deltaY > 0) {
                    direction = 'down';
                } else {
                    direction = 'up';
                }
            }
            // distX = e.originalEvent.changedTouches[0].pageX - startX;

        
              // 可以在这里添加更多的滑动逻辑，比如限制滑动的方向等
          });
          
        $(this).on('touchend', function(e) {
          distX = e.originalEvent.changedTouches[0].pageX - startX;
          distY = e.originalEvent.changedTouches[0].pageY - startY;
          // 根据水平方向的位移判断滑动方向
            console.log('根据水平方向的位移判断滑动方向');
          if (Math.abs(distX) > threshold) {
            if (distX > 3) {
              console.log('向右滑动',$(this).attr('data-index'));
              if($(this).attr('data-index')>2){
                if($(this).attr('data-index')<=1){
                  console.log('已经是第一张图片了');
                }else{
                  // left_width+=21;
                  console.log('点击之后的距离',$(this).attr('data-index'),left_width,$('.big_pic .flickity-viewport .Carousel__Cell').length);
                  // $('.Product__SlideshowMobileNav .flickity-page-dots').css('margin-left',left_width);
                  if($(this).attr('data-index')==$('.big_pic .flickity-viewport .Carousel__Cell').length-1){
                    console.log('点击的最后一张');
                    $('.last_tips').remove();
                  }
                }

              }
            } else {
              console.log('向左滑动',$(this).attr('data-index'));
              if($(this).attr('data-index')>2){
                if($(this).attr('data-index')>=$('.big_pic .flickity-viewport .Carousel__Cell').length-2){
                  console.log('最后一张');
                  $(this).append('<div class="last_tips"><span class="iconfont icon-Information-circle"></span>last picture</div>')
                }else{
                  // left_width-=21;
                  console.log('点击之后的距离',$(this).attr('data-index'),left_width);
                  // $('.Product__SlideshowMobileNav .flickity-page-dots').css('margin-left',left_width);
                }

              }

              // 滑动一次，向左滚动一次
            }
          }
        });
      })
    }

    var isClicked = false;
    // 点击加购弹窗的加减按钮
    var quickshop_num = parseInt($('.quick_shop_main .QuantitySelector__CurrentQuantity').val());
    console.log('总共几个',quickshop_num);
    $('.quick_shop_main .plus').click(function(){
      if (!isClicked) {
        console.log('点击加号');
        isClicked = true; // 设置为已点击
        $('.quick_shop_main .subduction').prop('disabled', false); // 重新启用按钮
        $(this).prop('disabled', true); // 禁用按钮防止重复点击
          console.log('加了几个',quickshop_num);
          var buy_out_price=$('.quick_shop_main .shopcar_m_title_price .buyout_out .buyout_price .money').text();
          var newStr_buy_out_price = buy_out_price.replace("$", ""); // 去掉 逗号
          console.log('内容02',buy_out_price,newStr_buy_out_price);
          var detail_old_price=$('.quick_shop .ProductItem__Info .Price--compareAt .money').text();
          var detail_old_price_str = detail_old_price.replace("$", "");
          var detail_now_price=$('.quick_shop .ProductItem__Info .Price--highlight .money').text();
          var detail_now_price_str = detail_now_price.replace("$", "");
          console.log('内容',detail_now_price_str,detail_old_price);
          quickshop_num+=1;
          $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value', quickshop_num);
          $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').val(quickshop_num).trigger('change');
          console.log('数量',quickshop_num,parseInt($('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value')));
          if(jQuery(window).width()<768){
            $('.quick_shop .quick_shop_bottom .ProductInfo_title_price_now').text('$' + (detail_now_price_str*$('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value')).toFixed(2));
            if ((detail_old_price_str ?? 0) > 0) {
              $('.quick_shop .quick_shop_bottom .ProductInfo_title_price_old').text('$' + (detail_old_price_str*$('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value')).toFixed(2));
            }
            $('.quick_shop .buy_btn_save .buyout_price .money').text('$' + (newStr_buy_out_price*$('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value')).toFixed(2));
          }
            // 执行异步操作，如Ajax请求，完成后重新启用按钮
            setTimeout(function() {
              isClicked = false; // 重置点击标识
              $('.plus').prop('disabled', false); // 重新启用按钮
          }, 1000);
      }
    })

    $('.quick_shop_main .subduction').click(function(){
      console.log('减了几个',quickshop_num);
      if(quickshop_num==1){
        console.log('值为1了,不能再减了',quickshop_num);
        $(this).prop('disabled', true);
      }else{
        console.log('不为1可以点击');
        if (!isClicked) {
          isClicked = true; // 设置为已点击
          $('.plus').prop('disabled', false); // 重新启用按钮
          $(this).prop('disabled', true); // 禁用按钮防止重复点击
            console.log('减了几个',quickshop_num);
            var buy_out_price=$('.quick_shop_main .shopcar_m_title_price .buyout_out .buyout_price .money').text();
            var newStr_buy_out_price = buy_out_price.replace("$", ""); // 去掉逗号
            console.log('内容02',newStr_buy_out_price);
            var detail_old_price=$('.quick_shop .ProductItem__Info .Price--compareAt .money').text();
            var detail_old_price_str = detail_old_price.replace("$", "");
            var detail_now_price=$('.quick_shop .ProductItem__Info .Price--highlight .money').text();
            var detail_now_price_str = detail_now_price.replace("$", "");
            console.log('内容',detail_now_price_str,detail_old_price);
            quickshop_num-=1;
            $('.quick_shop_main .QuantitySelector__CurrentQuantity').attr('value', quickshop_num);
            $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').val(quickshop_num).trigger('change');
            console.log('数量',quickshop_num);
            if(jQuery(window).width()<768){
              console.log('内容',((detail_old_price_str-detail_now_price_str)*($('.QuantitySelector__CurrentQuantity').val())));
              $('.quick_shop .quick_shop_bottom .ProductInfo_title_price_now').text('$' + (detail_now_price_str*($('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value'))).toFixed(2));
              if ((detail_old_price_str ?? 0) > 0) {
                $('.quick_shop .quick_shop_bottom .ProductInfo_title_price_old').text('$' + (detail_old_price_str*($('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value'))).toFixed(2));
              }
              $('.quick_shop .buy_btn_save .buyout_price .money').text('$' + (newStr_buy_out_price*($('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value'))).toFixed(2));
            }
            
            $('.quick_shop .buy_btn_save .buyout_price .money').text('$' + (newStr_buy_out_price*($('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value'))).toFixed(2));
              // 执行异步操作，如Ajax请求，完成后重新启用按钮
              setTimeout(function() {
                isClicked = false; // 重置点击标识
                $('.subduction').prop('disabled', false); // 重新启用按钮
            }, 1000);
        }
      }
      
    })
    // 关闭快速加购弹窗
    jQuery('.quick_shop .window-cover,.quick_shop .window-cover_con-close').click(function(){
      jQuery('.quick_shop .quick_shop_main').animate({'opacity':0},function(){
          jQuery('.quick_shop .quick_shop_main').hide();
          jQuery('.quick_shop .window-cover').hide();
          $('.quick-payment-out .quick-shop-quantity').append($('.quick_shop_ProductForm__Option .quick-shop-quantity-cen').clone());
          $('.quick-payment-out').append($('.quick_shop_bottom .quick_payment').clone()); // 复制整个 .aaa 并追加到 .bbb
          $('.quick_shop_ProductForm__Option .quick-shop-quantity-cen').remove();
          $('.quick_shop_bottom .quick_payment').remove();
          $('.quick_shop form .new_ProductItem_pic_wai .swiper-pagination').remove();
          $('.quick_shop_main .QuantitySelector__CurrentQuantity').attr('value', 1);
          $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').val(1).trigger('change');
      })
      jQuery('.quick_shop .window-cover').hide();
      $('body').css({
        'overflow': '',
        'position': '',
        'top': '',
        'left': '',
        'right': '',
        'bottom': ''
      });
      $(window).scrollTop($('body').attr('data-overflow-top'));
      $('html').css('overflow-y','auto');
  })


    option1= $('.quick_shop_main .option_cen:eq(0)').find('.is-active').text();
    option2= $('.quick_shop_main .option_cen:eq(1)').find('.is-active').text();
    option3= $('.quick_shop_main .option_cen:eq(2)').find('.is-active').text();

    var detail_old_price=$('.quick_shop .ProductItem__Info .ProductItem__PriceList .Price--compareAt .money').text();
    var detail_old_price_str = detail_old_price.replace("$", "");
    var detail_now_price=$('.quick_shop .ProductItem__Info .ProductItem__PriceList .Price--highlight .money').text();
    var detail_now_price_str = detail_now_price.replace("$", "");
        if(detail_old_price<=0){
          $('.product_detail_save').hide();
        }
    $('.product_detail_save').text( 'Save:$' + (detail_old_price_str-detail_now_price_str).toFixed(2));
    if(jQuery(window).width()<768){
      var detail_old_price=$('.quick_shop .shopcar_m_title_price .Price--compareAt .money').text();
      var detail_old_price_str = detail_old_price.replace("$", "");
      var detail_now_price=$('.quick_shop .shopcar_m_title_price .Price--highlight .money').text();
      var detail_now_price_str = detail_now_price.replace("$", "");
      console.log('价格',detail_old_price,detail_now_price);
      $('.quick_shop .quick_shop_bottom .ProductInfo_title_price_now').text(detail_now_price);
      if ((detail_old_price_str ?? 0) > 0) {
        $('.quick_shop .quick_shop_bottom .ProductInfo_title_price_old').text(detail_old_price);
      }
    }
    productId = '';
    skuId = '';
    sku_word = '';
    quantity = $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value');
    $(".quick_shop_main .option_cen").each(function(index){
        $(this).find('.ProductItem__ColorSwatchItem').each(function(newNum){
        $(this).off("click").on("click",function(){
          console.log('点击切换属性');
            // isClicked = true;
            $(this).find('.ColorSwatch').addClass('is-active');
            $(this).find('input').attr("checked", true);
            $(this).siblings().find('.ColorSwatch').removeClass('is-active');
            $(this).siblings().find('input').attr("checked", false);
            option1= $('.quick_shop_main .option_cen:eq(0)').find('.is-active').text();
            option2= $('.quick_shop_main .option_cen:eq(1)').find('.is-active').text();
            option3= $('.quick_shop_main .option_cen:eq(2)').find('.is-active').text();

            var detail_old_price=$('.quick_shop .ProductItem__Info .Price--compareAt .money').text();
            var detail_old_price_str = detail_old_price.replace("$", "");
            var detail_now_price=$('.quick_shop .ProductItem__Info .Price--highlight .money').text();
            var detail_now_price_str = detail_now_price.replace("$", "");
            $('.product_detail_save').text( 'Save:$' + (detail_old_price_str-detail_now_price_str).toFixed(2));
            var new_quantity_arr=[]; //库存
            jQuery(".quick_shop_main .ProductItem__Info .option_cen:eq(2) .ColorSwatch").removeClass('label_disabled');
            jQuery(".quick_shop_main .ProductItem__ColorSwatchItem").css("pointer-events", "auto");
            $('.quick_shop_main .quick_shop_button_cart').text('Add To Cart').css("pointer-events", "auto");
            $('.quick_shop_main .quick_shop_button_buy').removeClass('none');
            new_data_json.variants.forEach(function (variant,index) {
              console.log('切换属性内容',variant);
            if(variant.inventory_quantity<=0){
                new_quantity_arr.push(variant.options);
            }
            if(option3){
                if(variant.option1==option1&&variant.option2==option2&&variant.option3==option3){
                option1=variant.option1;
                option2=variant.option2;
                option3=variant.option3;
                $('.quick_shop_main .Price--highlight .money').text('$' + (variant.price/100));
                console.log('切换属性的原价',variant.compare_at_price);
                $('.quick_shop_main .quick_shop_bottom .ProductInfo_title_price_now').text('$' + ((variant.price/100)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                if ((variant.compare_at_price ?? 0) > 0) {
                  $('.quick_shop_main .Price--compareAt .money').text('$' + (variant.compare_at_price/100));
                  $('.quick_shop_main .quick_shop_bottom .ProductInfo_title_price_old').text('$' + ((variant.compare_at_price/100)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                }
                if($('.quick_shop_main .buyout_out').length>0){
                  var new_discount_num=$('.quick_shop_main .product_xinzheng_discount').text();
                  if($('.quick_shop_main .discount_type').text()=='1'){
                      // 百分比
                    var code_num = 1 - (new_discount_num/100);
                    $('.quick_shop_main .buyout_out .buyout_price .money').text('$'+(((variant.price/100)*code_num)).toFixed(2));
                    $('.quick_shop_main .quick_shop_bottom .buyout_out .buyout_price .money').text('$'+ (((variant.price/100)*code_num)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                  }
                  if($('.quick_shop_main .discount_type').text()=='2'){
                    // 满减
                    $('.quick_shop_main .buyout_out .buyout_price .money').text('$'+(((variant.price/100)-new_discount_num)).toFixed(2));
                    $('.quick_shop_main .quick_shop_bottom .buyout_out .buyout_price .money').text('$'+ (((variant.price/100)-new_discount_num)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                  }
                }
                //   jQuery(this).on('click', function () {
        
                productId = jQuery('.quick_shop form').attr('data-id');
                skuId = variant.id;
                sku_word = variant.sku;
                $('.quick_shop form').attr('sku-word',sku_word);

                $('.quick_shop_main .quick_shop_button_cart').off("click").on("click",function(){
                  quantity = $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value');
                  console.log('获取的加购数量',quantity);
                    console.log('点击弹窗加购按钮',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a .ptit').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                    DataLyer_push('add_to_cart',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a .ptit').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                    // 发送POST请求将产品添加到购物车
                    cart_api_one();
                })
                $('.quick_shop_main .quick_shop_button_buy').off("click").on("click",function(){
                  console.log('点击弹窗购买按钮',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a .ptit').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                    DataLyer_push('Buy Now',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a span').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                    cart_api_one_buy();
                })
                }
            }else{
                if(option2){
                  if(variant.option1 == option1 && variant.option2==option2){
                      option1=variant.option1;
                      option2=variant.option2;
                      $('.quick_shop_main .Price--highlight .money').text('$' + (variant.price/100));
                      
                      console.log('切换属性的原价',variant.compare_at_price);
                      $('.quick_shop_main .quick_shop_bottom .ProductInfo_title_price_now').text('$' + ((variant.price/100)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                      if ((variant.compare_at_price ?? 0) > 0) {
                        $('.quick_shop_main .Price--compareAt .money').text('$' + (variant.compare_at_price/100));
                        $('.quick_shop_main .quick_shop_bottom .ProductInfo_title_price_old').text('$' + ((variant.compare_at_price/100)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                      }
                      if($('.quick_shop_main .buyout_out').length>0){
                        var new_discount_num=$('.quick_shop_main .product_xinzheng_discount').text();
                        if($('.quick_shop_main .discount_type').text()=='1'){
                                      // 百分比
                          var code_num = 1 - (new_discount_num/100);
                          $('.quick_shop_main .buyout_out .buyout_price .money').text('$'+(((variant.price/100)*code_num)).toFixed(2));
                          $('.quick_shop_main .quick_shop_bottom .buyout_out .buyout_price .money').text('$'+ (((variant.price/100)*code_num)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                        }
                        if($('.quick_shop_main .discount_type').text()=='2'){
                          // 满减
                          $('.quick_shop_main .buyout_out .buyout_price .money').text('$'+(((variant.price/100)-new_discount_num)).toFixed(2));
                          $('.quick_shop_main .quick_shop_bottom .buyout_out .buyout_price .money').text('$'+ (((variant.price/100)-new_discount_num)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                        }
                      }
                      //   jQuery(this).on('click', function () {
              
                      productId = jQuery('.quick_shop form').attr('data-id');
                      skuId = variant.id;
                      sku_word = variant.sku;
                      $('.quick_shop form').attr('sku-word',sku_word);
                      $('.quick_shop_main .quick_shop_button_cart').off("click").on("click",function(){
                        quantity = $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value');
                        console.log('获取的加购数量',quantity);
                        console.log('点击弹窗加购按钮3',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a .ptit').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                        DataLyer_push('add_to_cart',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a .ptit').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                      // 发送POST请求将产品添加到购物车
                      cart_api_two();
                      // product_add_cart();
                      })
                      $('.quick_shop_main .quick_shop_button_buy').off("click").on("click",function(){
                        DataLyer_push('Buy Now',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a span').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                      cart_api_two_buy();
                      })
                  }
                }else{
                if(variant.option1 == option1){
                    option1=variant.option1;
                    $('.quick_shop_main .Price--highlight .money').text('$' + (variant.price/100));
                  
                    console.log('切换属性的原价',variant.compare_at_price);
                    $('.quick_shop_main .quick_shop_bottom .ProductInfo_title_price_now').text('$' + ((variant.price/100)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                    if ((variant.compare_at_price ?? 0) > 0) {
                      $('.quick_shop_main .Price--compareAt .money').text('$' + (variant.compare_at_price/100));
                      $('.quick_shop_main .quick_shop_bottom .ProductInfo_title_price_old').text('$' + ((variant.compare_at_price/100)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                    }
                    if($('.quick_shop_main .buyout_out').length>0){
                      var new_discount_num=$('.quick_shop_main .product_xinzheng_discount').text();
                      if($('.quick_shop_main .discount_type').text()=='1'){
                                    // 百分比
                        var code_num = 1 - (new_discount_num/100);
                        $('.quick_shop_main .buyout_out .buyout_price .money').text('$'+(((variant.price/100)*code_num)).toFixed(2));
                        $('.quick_shop_main .quick_shop_bottom .buyout_out .buyout_price .money').text('$'+ (((variant.price/100)*code_num)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                      }
                      if($('.quick_shop_main .discount_type').text()=='2'){
                        // 满减
                        $('.quick_shop_main .buyout_out .buyout_price .money').text('$'+(((variant.price/100)-new_discount_num)).toFixed(2));
                        $('.quick_shop_main .quick_shop_bottom .buyout_out .buyout_price .money').text('$'+ (((variant.price/100)-new_discount_num)*($('.quick_shop_main .QuantitySelector__CurrentQuantity').val())).toFixed(2));
                      }
                    }
                    //   jQuery(this).on('click', function () {
            
                    productId = jQuery('.quick_shop form').attr('data-id');
                    skuId = variant.id;
                    sku_word = variant.sku;
                    $('.quick_shop form').attr('sku-word',sku_word);
                    $('.quick_shop_main .quick_shop_button_cart').off("click").on("click",function(){
                      quantity = $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value');
                      console.log('获取的加购数量',quantity);
                      console.log('点击弹窗加购按钮2',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a .ptit').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                      DataLyer_push('add_to_cart',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a .ptit').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                    // 发送POST请求将产品添加到购物车
                    cart_api_only_one();
                    })
                    $('.quick_shop_main .quick_shop_button_buy').off("click").on("click",function(){
                      DataLyer_push('Buy Now',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a span').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                    cart_api_only_one_buy();
                    })
                }
                }

            }

            })
            for(let i = 0; i < new_quantity_arr.length; i++) {
            if(new_quantity_arr[i][0]==option1&&new_quantity_arr[i][1]==option2){
                jQuery(".quick_shop_main .ProductItem__Info .option_cen:eq(2) .ColorSwatch").each(function (j) {
                if($(this).text()==new_quantity_arr[i][2]){
                    $(this).addClass('label_disabled');
                    $(this).parent().css("pointer-events", "none");
                }
                })
            }
            }
            
            if($('.quick_shop_main .option_cen:eq(2)').find('.is-active').hasClass('label_disabled')) {
              $('.quick_shop_main .quick_shop_button_cart').text('Sold Out').css("pointer-events", "none");
              $('.quick_shop_main .quick_shop_button_buy').addClass('none');
            }

            })
        })

        })
        if (isClicked) {
        } else {
            productId = jQuery('.quick_shop form').attr('data-id');
            skuId = jQuery('.quick_shop form').attr('sku-id');
            $('.quick_shop_main .quick_shop_button_cart').off("click").on("click",function(){
              quantity = $('.quick_shop_main .quick-shop-quantity-cen .QuantitySelector__CurrentQuantity').attr('value');
              console.log('获取的加购数量',quantity);
              console.log('点击弹窗加购按钮1',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a .ptit').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                // 发送POST请求将产品添加到购物车
                DataLyer_push('add_to_cart',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a .ptit').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                console.log('点击加购');
                cart_api_one();
            })
            $('.quick_shop_main .quick_shop_button_buy').off("click").on("click",function(){
              DataLyer_push('Buy Now',$('.quick_shop_main .ProductItem__Info .Price--highlight .money').text(),$('.quick_shop_main .ProductItem__Info .ProductItem__Title a span').text(),$('.quick_shop form').attr('data-id'),$('.quick_shop form').attr('sku-word'));
                cart_api_one_buy();
            })
        }
      },
      error: function(xhr, status, error) {
        // 请求失败时的回调函数
        console.log('错误返回值02',error);
      }
    });
  }
          // 点击buy now 按钮进入结账页
      $('.Product__InfoWrapper .buy_now').off("click").on("click",function(){
        skuId=$(this).attr('sku-id');
        productId=$(this).attr('product-id');
        quantity=$('.quick_shop_main .QuantitySelector__CurrentQuantity').val();
        console.log('加购数量',quantity);
        $('.ProductForm__Variants .ProductForm__Option').each(function(index){
          option1=$('.ProductForm__Variants .ProductForm__Option').eq(0).find('.is-active').text();
          option2=$('.ProductForm__Variants .ProductForm__Option').eq(1).find('.is-active').text();
          option3=$('.ProductForm__Variants .ProductForm__Option').eq(2).find('.is-active').text();
          if($('.ProductForm__Variants .ProductForm__Option').length==1){
            cart_api_only_one_buy();
          }
          if($('.ProductForm__Variants .ProductForm__Option').length==2){
            cart_api_one_buy();
          }
          if($('.ProductForm__Variants .ProductForm__Option').length==3){
            cart_api_two_buy();
          }
        })
      })
      function cart_api_only_one(){
        // 发送POST请求将产品添加到购物车
        fetch('/cart/add.js', {
            method:'POST',
            headers: {'Content-Type':'application/json'},
            body:JSON.stringify({
            'form_type':"product",
            'id':skuId,
            'option-0':option1,
            'product-id':productId,
            'quantity': quantity
            })
        }).then(function(response) {
            // 处理响应
            if(response.ok) {
            $('.teast_popup p').text('The item has been added to cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(5000).fadeOut("slow");
            window.location.href ="https://www.klaiyihair.com/cart";
            //  location.href ="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart')+ "?ew_m=f"
            
            }else{
            $('.teast_popup p').text('Failed to add shopping cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(3000).fadeOut("slow");
            }
        })
        .catch(function(error) {
            console.error('Failed to add shopping cart：', error);
        });
      }
      function cart_api_only_one_buy(){
        fetch('/cart/add.js', {
            method:'POST',
            headers: {'Content-Type':'application/json'},
            body:JSON.stringify({
            'form_type':"product",
            'id':skuId,
            'option-0':option1,
            'product-id':productId,
            'quantity': quantity
            })
        }).then(function(response) {
            // 处理响应
            if(response.ok) {
            $('.teast_popup p').text('The item has been added to cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(5000).fadeOut("slow");
                var checkout_href="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart');
                $('.quick_shop_main .quick_shop_button_buy').attr('href',checkout_href);
            location.href ="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart');
            
            }else{
            $('.teast_popup p').text('Failed to add shopping cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(3000).fadeOut("slow");
            }
        })
        .catch(function(error) {
            console.error('Failed to add shopping cart：', error);
        });
      }
      function cart_api_one(){
                  // 发送POST请求将产品添加到购物车
                  fetch('/cart/add.js', {
                  method:'POST',
                  headers: {'Content-Type':'application/json'},
                  body:JSON.stringify({
                      'form_type':"product",
                      'id':skuId,
                      'option-0':option1,
                      'option-1':option2,
                      'option-3':option3,
                      'product-id':productId,
                      'quantity': quantity
                  })
                  }).then(function(response) {
                  // 处理响应
                  if(response.ok) {
                      $('.teast_popup p').text('The item has been added to cart');
                      $(".teast_popup").removeClass('none');
                      $(".teast_popup").delay(5000).fadeOut("slow");
                      window.location.href ="https://www.klaiyihair.com/cart";
                      //  location.href ="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart')+ "?ew_m=f"
                  
                  }else{
                      $('.teast_popup p').text('Failed to add shopping cart');
                      $(".teast_popup").removeClass('none');
                      $(".teast_popup").delay(3000).fadeOut("slow");
                  }
                  })
                  .catch(function(error) {
                  console.error('Failed to add shopping cart：', error);
                  });
      }
      function cart_api_one_buy(){
        fetch('/cart/add.js', {
            method:'POST',
            headers: {'Content-Type':'application/json'},
            body:JSON.stringify({
            'form_type':"product",
            'id':skuId,
            'option-0':option1,
            'option-1':option2,
            'option-3':option3,
            'product-id':productId,
            'quantity': quantity
            })
        }).then(function(response) {
            // 处理响应
            if(response.ok) {
            $('.teast_popup p').text('The item has been added to cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(5000).fadeOut("slow");
                var checkout_href="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart');
                $('.quick_shop_main .quick_shop_button_buy').attr('href',checkout_href);
            location.href ="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart');
            
            }else{
            $('.teast_popup p').text('Failed to add shopping cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(3000).fadeOut("slow");
            }
        })
        .catch(function(error) {
            console.error('Failed to add shopping cart：', error);
        });
      }
      function cart_api_two(){
        // 发送POST请求将产品添加到购物车
        fetch('/cart/add.js', {
            method:'POST',
            headers: {'Content-Type':'application/json'},
            body:JSON.stringify({
            'form_type':"product",
            'id':skuId,
            'option-0':option1,
            'option-1':option2,
            'product-id':productId,
            'quantity': quantity
            })
        }).then(function(response) {
            // 处理响应
            if(response.ok) {
            $('.teast_popup p').text('The item has been added to cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(5000).fadeOut("slow");
            window.location.href ="https://www.klaiyihair.com/cart";
            //  location.href ="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart')+ "?ew_m=f"
            
            
            }else{
            $('.teast_popup p').text('Failed to add shopping cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(3000).fadeOut("slow");
            }
        })
        .catch(function(error) {
            console.error('Failed to add shopping cart：', error);
        });
      }
      function cart_api_two_buy(){
        fetch('/cart/add.js', {
            method:'POST',
            headers: {'Content-Type':'application/json'},
            body:JSON.stringify({
            'form_type':"product",
            'id':skuId,
            'option-0':option1,
            'option-1':option2,
            'option-3':option3,
            'product-id':productId,
            'quantity': quantity
            })
        }).then(function(response) {
            // 处理响应
            if(response.ok) {
            $('.teast_popup p').text('The item has been added to cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(5000).fadeOut("slow");
                var checkout_href="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart');
                $('.quick_shop_main .quick_shop_button_buy').attr('href',checkout_href);
            location.href ="https://www.klaiyihair.com/checkouts/cn/"+ $.cookie('cart');
            
            }else{
            $('.teast_popup p').text('Failed to add shopping cart');
            $(".teast_popup").removeClass('none');
            $(".teast_popup").delay(3000).fadeOut("slow");
            }
        })
        .catch(function(error) {
            console.error('Failed to add shopping cart：', error);
        });
      }
      function product_add_cart(){
        fetch('/cart/add.js', {
            method:'POST',
            headers: {'Content-Type':'application/json'},
            body:JSON.stringify({
            'form_type':"product",
            'id':skuId,
            'option-0':option1,
            'option-1':option2,
            'option-2':option3,
            'product-id':productId,
            'quantity': quantity
            })
        }).then(function(response) {
            // 处理响应
            if(response.ok) {
              location.href ="https://www.klaiyihair.com/cart";
              // 监听页面即将离开的事件
            window.addEventListener('beforeunload', function(event) {
              
              // 判断是否是因为 Shopify 的购物车跳转
              if (event.target.location.href.includes('/cart')) {
                // 阻止跳转
                event.preventDefault();
                // 在这里可以执行自定义的逻辑
              }
            });

              // location.href ="https://www.klaiyihair.com/cart";
            
            }else{
              $('.teast_popup p').text('Failed to add shopping cart');
              $(".teast_popup").removeClass('none');
              $(".teast_popup").delay(3000).fadeOut("slow");
            }
        })
        .catch(function(error) {
            console.error('Failed to add shopping cart：', error);
        });
      }

}
function updatePopupHeight() {
  let viewportHeight = window.innerHeight; 
  let popup = document.querySelector('.quick_shop_main'); 
  popup.style.maxHeight = viewportHeight + 'px'; 
}
// 监听窗口大小变化，防止后续打开时出错
window.addEventListener('resize', updatePopupHeight);
jQuery(function(){
  // 点击弹窗按钮复制内容
  var tanchuang_click_num=0;
  jQuery('.pop_detail_button').each(function(){
    jQuery(this).on('click', function () {
      tanchuang_click_num+=1;
      if(tanchuang_click_num==1){
        copyText(jQuery(this).find('.pop_code_num').text().trim());
        jQuery(this).find('i').text('copied').addClass('copied');
        jQuery(this).find('svg').remove();
        jQuery(this).find('.pop_text').append(',');
        jQuery(this).append('<span class="popup_shop_now"> Shop Now>></span>');
      }else{
        jQuery(this).parent().parent().parent().hide();
        $('.pop_cover').hide();
      }

      // setTimeout(function(){    
      //     jQuery(this).find('i').text('copy'); 
      //     jQuery(this).find('i').removeClass('copied'); 
      // },1000);
    })
  })

  function copyText(text) {
    // Wait for the DOM to be ready
    if (document.body) {
      var oInput = document.createElement('input');
      oInput.value = text;
      document.body.appendChild(oInput);  // Append the input field to body
      oInput.select();  // Select the text
      document.execCommand("Copy");  // Execute the copy command
      oInput.className = 'oInput';
      oInput.style.display = 'none';  // Hide the input after copying
    } else {
      console.warn('Body element is not available!');
    }
  }

  if(window.location.pathname=="/collections/wigs"){
    const url = window.location;
    const arr = url.pathname.split('/');
    arr.pop();
    arr.push('wig');
    const newUrl = url.origin + arr.join('/') + url.search;
    history.pushState('', '', newUrl); // 不刷新页面
  }

})
  // 倒计时
  function getLocalTime(i) {
    if (typeof i !== 'number') return;
    var d = new Date();
    var len = d.getTime();
    var offset = d.getTimezoneOffset() * 60000;
    var utcTime = len + offset;
    return new Date(utcTime + 3600000 * i);
  }
  
  window.getNextDate = function(date, day) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "/" + m + "/" + d;
  }
  var timeZoneParams = -5;
  jQuery(function() {
      if (jQuery('.endsIn').length || jQuery('.memberFlash-timeBox').length) {
          var date = getLocalTime(timeZoneParams);
          var date_day = date.getDate();
          var date_month = date.getMonth() + 1;
          var date_year = date.getFullYear();
          var endTime = getNextDate(date_year + '/' + date_month + '/' + date_day, 1);
          var endAllTime = new Date(endTime).getTime() - date;
  
          function timerMember(intDiff) {
              var hour = 0,
                  minute = 0,
                  second = 0;
              intDiff = intDiff - 0;
              if (intDiff > 0) {
                  hour = Math.floor(intDiff / 1000 / 60 / 60);
                  minute = Math.floor(intDiff / 1000 / 60 % 60);
                  second = Math.floor(intDiff / 1000 % 60);
              }
              if (hour < 10) {
                  hour = '0' + hour;
              }
              if (minute < 10) {
                  minute = '0' + minute;
              }
              if (second < 10) {
                  second = '0' + second;
              }
            if (jQuery('.flashSale-clock_timeH').length){
               jQuery('.flashSale-clock_timeH').text(hour);
              jQuery('.flashSale-clock_timeM').text(minute);
              jQuery('.flashSale-clock_timeS').text(second);
            }

              // 时
              var str1 = hour + '';
              var s1 = str1.substr(0, 1);
              if (jQuery('.memberFlash-time_timeH_one').length){
               jQuery('.memberFlash-time_timeH_one').text(s1);
                jQuery('.memberFlash-time_timeH_two').text(str1.charAt(str1.length-1));
              }
 
               // 分
                var str2=minute + ''; 
                var s2=str2.substr(0, 1);
                if (jQuery('.memberFlash-time_timeM_one').length){
                  jQuery('.memberFlash-time_timeM_one').text(s2);
                  jQuery('.memberFlash-time_timeM_two').text(str2.charAt(str2.length-1));
                }
 
                // 秒
                var str3=second + ''; 
                var s3=str3.substr(0, 1);
              if (jQuery('.memberFlash-time_timeS_one').length){
                jQuery('.memberFlash-time_timeS_one').text(s3);
                jQuery('.memberFlash-time_timeS_two').text(str3.charAt(str3.length-1));
              }

          }
          var groupTime = setInterval(function() {
              if (endAllTime > 0) {
                  timerMember(endAllTime);
                  endAllTime -= 1000;
              } else {
                  date = getLocalTime(timeZoneParams);
                  date_day = date.getDate();
                  date_month = date.getMonth();
                  date_year = date.getFullYear();
                  endTime = getNextDate(date_year + '/' + date_month + '/' + date_day);
                  endAllTime = new Date(endTime).getTime() - date;
              }
          }, 1000);
      }
  
  })
  
   
   
   
  
    // 倒计时结束
    
    // m 端底部展开切换
    function foot_nav(){
      if(jQuery(window).width()<768){
        jQuery('.newicondown').removeClass('iconHidden');
        jQuery(".Footer__Inner .Footer__Block--links").each(function(index,ele){
            jQuery(this).find('.Footer__Title').on('click', function () {
                jQuery(this).parent('.Footer__Block--links').find('.Linklist').toggleClass('linklist_content');
                if(jQuery(this).find('.newicondown').hasClass('icon-expand')){
                            jQuery(this).find('.newicondown').addClass('icon-fold').removeClass('icon-expand');
                }else{
                    jQuery(this).find('.newicondown').addClass('icon-expand').removeClass('icon-fold');
        
                }
            })
    
      })
    }else{
        jQuery('.Footer__Title .newicondown').addClass('iconHidden');
    }
  }
  foot_nav();
  jQuery(window).resize(function(){
    foot_nav();
  });
  
  //pc登录
  function user_login_icon(){
    if(jQuery(window).width()>=768){
      jQuery('.new_pc_user').css('display','none');
    
    }else{
      jQuery('.new_pc_user').css('display','block');
    }
  }
  user_login_icon();
  jQuery(window).resize(function(){
    user_login_icon();
  })

  // 向右按钮切换
  jQuery(".shopcar_arrow").each(function () {
    jQuery(this).on('click', function () {
      if(jQuery(this).hasClass("icon-Pluse")){
          jQuery(this).removeClass('icon-Pluse').addClass('icon-fold');
          jQuery(this).parent().siblings('.Collapsible__Inner').css('height','auto');
          jQuery(this).parent().siblings('.Collapsible__Inner').css('visibility','visible');
      }else{
        jQuery(this).addClass('icon-Pluse').removeClass('icon-fold');
        jQuery(this).parent().siblings('.Collapsible__Inner').css('height','0');
        jQuery(this).parent().siblings('.Collapsible__Inner').css('visibility','hidden');
      }
    
    })
  })
// blog伸缩
  jQuery('.shopcar_arrow_blog').on('click', function () {
    if(jQuery('.blog_collapsible__Inner').hasClass('blog_Collapsible__Inner_hide')){
      jQuery('.blog_collapsible__Inner').addClass('blog_Collapsible__Inner_show').removeClass('blog_Collapsible__Inner_hide');
    }else{
      jQuery('.blog_collapsible__Inner').addClass('blog_Collapsible__Inner_hide').removeClass('blog_Collapsible__Inner_show');
    }
  
  })


  jQuery(".Header__LogoLink").on("click",function(){
   window.location.href="https://www.klaiyihair.com/"
  
  });
  // 小图切换
    var allpic=jQuery(".Product__SlideshowNavScroller .Product__SlideshowNavImage").length-6;
    jQuery(".Product__SlideshowNav").before('<i class="iconfont icon-up newicon_up"></i>')
    jQuery(".Product__SlideshowNav").after('<i class="iconfont icon-down newicon_down"></i>')
    var newtop='72px'
    jQuery(".newicon_down").off("click").on("click",function(){
        jQuery('.newicon_up').css('color','#000');
        if(jQuery('.Product__SlideshowNavScroller').position().left<=-top*allpic){
            jQuery('.newicon_down').css('color','#d5d1d1');
        }else{
            jQuery('.Product__SlideshowNavScroller').animate({
                top: '-='+newtop
            }, '500')
            jQuery('.newicon_down').css('color','#000');
        }
    });
    jQuery(".newicon_up").off("click").on("click",function(){
        jQuery('.newicon_down').css('color','#000');
        if(jQuery('.Product__SlideshowNavScroller').position().top>=0){
  
            jQuery('.newicon_up').css('color','#d5d1d1');
        }else{
            jQuery('.Product__SlideshowNavScroller').animate({
                top: '+='+newtop
            }, '500')
            jQuery('.newicon_up').css('color','#000');
        }
  
    });

  jQuery(window).resize(function(){
  // 小图切换
  if(jQuery(window).width()>=769){
    jQuery('.newicon_up').css('display','inline-block');
    jQuery('.newicon_down').css('display','inline-block');
    
  }else{
     jQuery('.newicon_up').css('display','none');
    jQuery('.newicon_down').css('display','none');
  }
  })
  //google页面
  // tab切换
function tab_change(item){
  item.addClass('active') // 返回 item
  .siblings() // 返回ul下li的兄弟
  .removeClass('active') // 返回ul下li的兄弟
  .parent() // 返回ul
  .next() // 返回ol
  .children() // 返回ol下所有li
  .eq(item.index()) // 返回ol下的一个li
  .addClass('active') // 返回ol下的一个li
  .siblings() // 返回ol下li的兄弟
  .removeClass('active') // 返回ol下li的兄弟
}
  jQuery(".recommendation_con .recommendation_con_title_list").off("click").on("click",function(){
    tab_change(jQuery(this));
  })
//详情销售服务
  jQuery(".sales_service_popup .sales_service_popup_title li").off("click").on("click",function(){
    tab_change(jQuery(this));
  })
  //首页销售服务
  jQuery(".home_sales_service_popup .home_sales_service_popup_title li").off("click").on("click",function(){
    tab_change(jQuery(this));
  })
//详情描述的tab
  jQuery(".product_des_tab .title_tab li").off("click").on("click",function(){
    tab_change(jQuery(this));
  })
// 博客页面右侧产品切换
  jQuery(".side_blog_mayLike_title .mayLike_title_tab").off("click").on("click",function(){
    tab_change(jQuery(this));
  })
  jQuery(".side_blog_mayLike_title .colored_wigs_tab").off("click").on("click",function(){
    tab_change(jQuery(this));
  })
// 登录注册弹窗切换
 if(jQuery(window).width()<769){
  jQuery("#login_register .Form__Header .Form__Title").off("click").on("click",function(){
    tab_change(jQuery(this));
  })
 }
// 详情页第二模板tab切换
  jQuery(".product_detail_all_template .detail_first_title").off("click").on("click",function(){
    tab_change(jQuery(this));
  })
  // 品牌日tab按钮切换
  jQuery(".Top_sell_wig .title_list").off("click").on("click",function(){
    tab_change(jQuery(this));
  })
  // 首页弹窗
  // 首页卖点服务弹窗
  jQuery(function() {
    jQuery("#shopify-section-template--15781914968198__16599265181b245b62 .service_list").each(function(index){
          jQuery(this).off("click").on("click",function(){
            home_service(index);
          })
    })

  })


  function home_service(index){
    $('.home_sales_service_popup_title li').eq(index).addClass('active').siblings().removeClass('active');
    $('.home_sales_service_popup_con li').eq(index).addClass('active').siblings().removeClass('active');
       jQuery('.home_sales_service_popup .window-cover').show();
       jQuery('.home_sales_service_popup .pop_main').show();
       jQuery('.home_sales_service_popup .pop_main .pop_con').css({'top':0,'opacity':0})
       jQuery('.home_sales_service_popup .pop_main .pop_con').animate({'top':'50%','opacity':1})
  }
  // 首页轮播
var mySwiper = new Swiper('.google_page_pic',{
  pagination : '.google_page_swiper-pagination',
  slidesPerView: 1,
  paginationClickable: true,
  autoplay:3000,
})
var mySwiper = new Swiper('.google_page_pic_m',{
  pagination : '.google_page_m_swiper-pagination',
  slidesPerView: 1,
  paginationClickable: true,
  autoplay:3000,
})
    var mySwiper = new Swiper('.google_banner_pc',{
          pagination: '.swiper-pagination',
          slidesPerView: 1,
          paginationClickable: true,
          spaceBetween: 20,
    })
    var mySwiper = new Swiper('.new_google_banner_m',{
          pagination: '.swiper-pagination',
          slidesPerView: 1,
          paginationClickable: true,
          spaceBetween: 20,
    })

    var mySwiper = new Swiper('.home_moments_m',{
          pagination: '.swiper-pagination',
          slidesPerView: 1.5,
          paginationClickable: true,
          spaceBetween: 5,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
    })

    if(jQuery(window).width()>=769){
      // 首页倒数第二个板块
      var mySwiper = new Swiper('.about_klaiyi_pc',{
            pagination: '.swiper-pagination',
            slidesPerView: 2,
            paginationClickable: true,
            spaceBetween: 32,
            nextButton: '.swiper-button_next_about_klaiyi',
            prevButton: '.swiper-button_prev_about_klaiyi',
      })
      // 首页金刚区轮播
      var swiper = new Swiper('.Jingang_district_pc', {
        pagination: '.Jingang_district_pc_swiper-pagination',
        slidesPerView: 5.6,
        slidesPerGroup: 1, // 每次滑动1个 slide
        paginationClickable: true,
        spaceBetween: 32,
        nextButton: '.swiper-button_next_jingang_pc',
        prevButton: '.swiper-button_prev_jingang_pc',
      });
        var mySwiper = new Swiper('.home_moments_pc',{
          pagination: '.swiper-pagination',
          slidesPerView: 5,
          paginationClickable: true,
          spaceBetween: 20,
          nextButton: '.swiper-button_next_home_moments_pc',
          prevButton: '.swiper-button_prev_home_moments_pc',
        })
      // 谷歌页面flash sale轮播
      var mySwiper = new Swiper('.flash_sale_con',{
        slidesPerView: 4.5,
        paginationClickable: true,
        spaceBetween: 30,
        prevButton:'.flash_sale_con_prev',
        nextButton:'.flash_sale_con_next',
      })
      // 100off页面
      var mySwiper = new Swiper('.swiper_product',{
        slidesPerView: 3.5,
        paginationClickable: true,
        spaceBetween: 30,
      })
      var mySwiper = new Swiper('.home_moments_img',{
        slidesPerView: 5,
        paginationClickable: true,
        spaceBetween: 20,
        nextButton: '.swiper-button_next_home_moments_img',
        prevButton: '.swiper-button_prev_home_moments_img',
      })
            // 主图滑动
      var mySwiper_new_ProductItem_pic_wai = new Swiper('.new_ProductItem_pic_wai',{
            slidesPerView: 1,
            paginationClickable: true,
            spaceBetween: 5,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
      })

      var mySwiper = new Swiper('.product2_pc',{
          pagination: '.swiper-pagination',
          slidesPerView: 4,
          paginationClickable: true,
          spaceBetween: 4,
          nextButton: '.swiper-button_next_product2_pc',
          prevButton: '.swiper-button_prev_product2_pc',
      })
    }
    if(jQuery(window).width()<=768){
            // 首页倒数第二个板块
          var mySwiper = new Swiper('.about_klaiyi_pc',{
                pagination: '.swiper-pagination',
                slidesPerView: 1.3,
                paginationClickable: true,
                spaceBetween: 8,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
          })
            // 首页金刚轮播
        var swiper = new Swiper('.Jingang_district_m', {
          pagination: '.Jingang_district_m_swiper-pagination',
          slidesPerView: 1,
          paginationClickable: true,
        });
        var mySwiper = new Swiper('.home_moments_pc',{
          pagination: '.swiper-pagination',
          slidesPerView: 1.5,
          paginationClickable: true,
          spaceBetween: 5,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
        })
      // 谷歌页面flash sale轮播
      var mySwiper = new Swiper('.flash_sale_con',{
        slidesPerView: 2.2,
        paginationClickable: true,
        spaceBetween: 10,
        prevButton:'.flash_sale_con_prev',
        nextButton:'.flash_sale_con_next',
      })
      var mySwiper = new Swiper('.swiper_product',{
        slidesPerView: 1.3,
        paginationClickable: true,
        spaceBetween: 10,
      })
      var mySwiper = new Swiper('.home_moments_img',{
        pagination: '.swiper-pagination',
        slidesPerView: 2.2,
        paginationClickable: true,
        spaceBetween: 20,
      })
      var mySwiper = new Swiper('.product2_pc',{
          pagination: '.swiper-pagination',
          slidesPerView: 2.2,
          paginationClickable: true,
          spaceBetween: 2.2,
      })
    }
    if(jQuery(window).width()>=769){
      var mySwiper = new Swiper('.product2_anniversary',{
          pagination: '.swiper-pagination',
          slidesPerView: 5,
          paginationClickable: true,
          spaceBetween: 5,
          nextButton: '.swiper-button_next_product2_anniversary',
          prevButton: '.swiper-button_prev_product2_anniversary',
      })
      var mySwiper = new Swiper('.product2_tax',{
          pagination: '.swiper-pagination',
          slidesPerView: 4,
          paginationClickable: true,
          spaceBetween: 20,
          nextButton: '.swiper-button_next_product2_tax',
          prevButton: '.swiper-button_prev_product2_tax',
      })
    }
    if(jQuery(window).width()<=768){
      var mySwiper = new Swiper('.product2_anniversary',{
          pagination: '.swiper-pagination',
          slidesPerView: 2.2,
          paginationClickable: true,
          spaceBetween: 2.2,
      })
      var mySwiper = new Swiper('.product2_tax',{
          pagination: '.swiper-pagination',
          slidesPerView: 2.2,
          paginationClickable: true,
          spaceBetween: 15,
      })
    }


// 详情页产品推荐
    if(jQuery(window).width()>=769){

      var mySwiper = new Swiper('.product2_detail',{
          pagination: '.swiper-pagination',
          slidesPerView: 5,
          paginationClickable: true,
          spaceBetween: 20,
          nextButton: '.swiper-button_next_product2_detail',
          prevButton: '.swiper-button_prev_product2_detail',
      })
      var may_like_mySwiper_pc = new Swiper('.may_like_product2_detail',{
          pagination: '.swiper-pagination',
          slidesPerView: 4,
          paginationClickable: true,
          spaceBetween: 20,
          nextButton: '.swiper-button_next_pc_may_like',
          prevButton: '.swiper-button_prev_pc_may_like',
      })
      var description_con_swiper = new Swiper('.collection_foot_description_con',{
        pagination: '.swiper-pagination',
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 32,
        nextButton: '.swiper-button_next_pc_collection_foot_description',
        prevButton: '.swiper-button_prev_pc_collection_foot_description',
    })
      
    }
    if(jQuery(window).width()<=768){
            // banner轮播
      var mySwiper = new Swiper('.new_google_banner_m',{
        pagination: '.swiper-pagination',
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 5,
      })
      var mySwiper = new Swiper('.product2_detail',{
          pagination: '.swiper-pagination',
          slidesPerView: 2.2,
          paginationClickable: true,
          spaceBetween: 10,
      })
      if(url.indexOf("/products/") >= 0 ) { 
        var may_like_m_swipeCount = 0;
        var left_width=0;
         may_like_mySwiper_m = new Swiper('.may_like_product',{
             pagination: '.swiper-pagination_may_like_product',
            slidesPerView: 2,
            slidesPerGroup: 2,//一次滚动的个数
            paginationClickable: true,
            spaceBetween: 10,
            onTouchStart: function (swiper, event) {
              // 在这里可以添加你的逻辑来处理滑动开始的情况
            },
            onTouchMove: function (swiper, event) {
            
              // 在这里可以添加你的逻辑来处理滑动中的情况
            },
            onTouchEnd: function (swiper, event) {
  
              
            }
        })
        may_like_mySwiper_m.on('slideChangeEnd', function () {
          var previousIndex = may_like_mySwiper_m.previousIndex;
          var currentIndex = may_like_mySwiper_m.activeIndex;
          if (currentIndex > previousIndex) {
            var all_length=Math.ceil($('.m_may_like .swiper-wrapper').length/2)-3;
            may_like_m_swipeCount++;
            if(may_like_m_swipeCount >=3){
              if(may_like_m_swipeCount < all_length){
                left_width ="-" +(20*Number(may_like_m_swipeCount-3));
                $('.may_like_pagination_wai .swiper-pagination').css('left', left_width+'px');
              }
  
            }
          } else {
            var all_length=Math.ceil($('.m_may_like .swiper-wrapper').length/2)-3;
            may_like_m_swipeCount--;
            if(may_like_m_swipeCount >=3){
              if(may_like_m_swipeCount < all_length){
                left_width ="-" +(20*Number(may_like_m_swipeCount-3));
                $('.may_like_pagination_wai .swiper-pagination').css('left', left_width+'px');
              }
  
            }
          }
        });
      }

    }
            // banner轮播
      var mySwiper = new Swiper('.banner_google',{
        pagination: '.swiper-pagination',
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 5,
      })
  // ga埋点(2023.12.15)
    var customerId=email;
    var userEmail=email;;
    var url = window.location.href;
  window.getGaClientId = function () {
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          if (ca[i].match(/^\s*_ga=GA.*/g)) {
              var gid = ca[i];
              break;
          }
      }
      var clientId = gid ? gid.replace(/_ga=GA.\..\./, "") :'';
      return clientId;
  }
  var clientId = getGaClientId();
  // 注册登录埋点
window.registerBurialPoint = function() {
  var category = 'login';
  var action = '';

  if (window.location.pathname=='/account/register') {
    action = 'registe';
  } 
  if (window.location.pathname == '/account/login') {
    action = 'login';
  }
  if (clientId !== '') {
    sendBurialPoint(action, customerId, '', category, clientId);
  }
  
};
// 加购
$(document).on('click', '.ProductForm__AddToCart', function(){
  _updateAddToCartButton();
})
// 加购
$(document).on('click', '.buy_now ', function(){
  _updateToBuy();
})
// 快速购买
$(document).on('click', '.shopify-payment-button', function(){
 orderFormBurialPoint();
})

// 点击埋点
$(document).on('click', '.ProductItem', function() {
  var productID = $(this).attr('data-product-id');
  var category = '';
  if (window.location.pathname == '/') {
    category = 'homePage';
  } 
  if(url.indexOf("/collections") >= 0 ) { 
    category = 'proList';
  }
  if(url.indexOf("/products") >= 0 ) { 
    category = 'proDetails';
  }
  if (clientId !== '') {
    if (window.customerData && window.customerData.loggedIn) {
        sendBurialPoint('click', customerId, productID, category, clientId, userEmail);
    }else {
        sendBurialPoint('click', customerId, productID, category, clientId);  
    }
  }
});

// 加购埋点
window._updateAddToCartButton = function(_this) {
  var productID = $('.ProductForm__AddToCart').attr('product-id');
  var category = '';

  if (window.location.pathname == '/') {
    category = 'homePage';
  } 
  if(url.indexOf("/collections") >= 0 ) { 
    category = 'proList';
  }
  if(url.indexOf("/products") >= 0 ) { 
    category = 'proDetails';
  }
  if (clientId !== '') {
    if (window.customerData && window.customerData.loggedIn) {
      sendBurialPoint('cart', customerId, productID, category, clientId, userEmail);
    }else {
        sendBurialPoint('cart', customerId, productID, category, clientId);  
    }
  }
};
// 点击购买埋点
window._updateToBuy = function(_this) {
  var productID = $('.buy_now').attr('product-id');
  var category = '';

  if (window.location.pathname == '/') {
    category = 'homePage';
  } 
  if(url.indexOf("/collections") >= 0 ) { 
    category = 'proList';
  }
  if(url.indexOf("/products") >= 0 ) { 
    category = 'proDetails';
  }
  if (clientId !== '') {
    if (window.customerData && window.customerData.loggedIn) {
      sendBurialPoint('order_submit', customerId, productID, category, clientId, userEmail);
    }else {
        sendBurialPoint('order_submit', customerId, productID, category, clientId);  
    }
  }
};

// 提交订单埋点
window.orderFormBurialPoint = function(email) {
  var productID = $('.ProductForm__AddToCart').attr('id');
  var category = 'checkout';
  if (clientId !== '') {
    if (window.customerData && window.customerData.loggedIn) {
      sendBurialPoint('cart', customerId, productID, category, clientId, email);
    }else {
      sendBurialPoint('cart', customerId, productID, category, clientId);  
    }
      
  }

};

// 支付成功
// window.paymentBurialPoint = function () {
//   var productId = [];
//   $('.order-product .order-product_item').each(function () {
//       productId.push($(this).attr('product_id'))
//   }) 
//   if (clientId !== '') {
//     sendBurialPoint('order_done', customerId, productId, 'checkout', clientId);
//   }
// };
  

var GAiiv = function isInView(o){
  typeof o[0]==='undefined'?o=o:o=o[0];
  if(o instanceof HTMLElement){
  var vph = window.innerHeight, wpw = window.innerWidth;
  var oRect=o.getBoundingClientRect();
  var ott = oRect.top+oRect.height*0.5;
  var otl = oRect.left+oRect.width*0.5;
  return (ott>0 && ott<vph && otl>0 && otl<wpw);
  }else{return false;}
}
var GAgdb=function gaDebounce(fn, wait){
  var timeout = null;
  return function() {
      if(timeout !== null){clearTimeout(timeout);}
      timeout = setTimeout(fn, wait);
  }
}
var flagViewObj=new Object();
function handle(){
    var product_ids=[];

    if (jQuery('.ProductItem').length){
      jQuery('.ProductItem').each(function(){
         if((typeof flagViewObj[jQuery(this).attr('data-product-id')]=='undefined')&&GAiiv($(this))){
             product_ids.push(jQuery(this).attr('data-product-id'));
             flagViewObj[jQuery(this).attr('data-product-id')]=null; 
          }
      })
 }

   if (product_ids.length != 0) { 
       window.exposureBurialPoint(product_ids)
  }

}
$(function () { 
  if ($('.ProductItem ').length != 0) { 
      window.addEventListener('scroll', GAgdb(handle, 1000));
  }     
})
  

  // 曝光埋点
  window.exposureBurialPoint = function(productIDs) {
    // var productID = $(this).attr('product_id');
    var category = '';
    if (window.location.pathname == '/') {
      category = 'homePage';
    } 
    if(url.indexOf("/collections") >= 0 ) { 
      category = 'proList';
    }
    if(url.indexOf("/products") >= 0 ) { 
      category = 'proDetails';
    }
    if (clientId !== '') {
      if (window.customerData && window.customerData.loggedIn) {
            sendBurialPoint('show', customerId, productIDs, category, clientId, userEmail);
        }else {
            sendBurialPoint('show', customerId, productIDs, category, clientId);
        }
       
    }
  };

// 封装发送埋点请求的方法
function sendBurialPoint(action, userId, productId, category, clientId, email) {
  var body_data = { 
      action
      };
      userId ? body_data.userId = userId : '';
      clientId ? body_data.clientId = clientId : '';
      productId ? body_data.productId= productId : '';
      category ? body_data.category = category : '';
      email ? body_data.email = email:'';
    var form = new FormData();
    form.append("body", JSON.stringify(body_data));
    form.append('shop_name','Klaiyi');
    $.ajax({
      "url": "https://plugin.kriyya.com/api/SqsRequest",
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5"
      },
      "processData": false,
      "mimeType": "multipart/form-data",
      "contentType": false,
      "data": form,
      success: function(res) {
      },
      error:function(req){
        console.log('错误返回值',req);
      }
    });
}

// DataLyer传值内容
function DataLyer_push(button_name,total_price,product_name,product_id,sku_word) {
  console.log('点击的信息',button_name,total_price,product_name,product_id,sku_word);
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
      event: "dle_add_to_cart",
      dlv_ea: 'productAdd',
      dlv_el: button_name,
      dlv_cu: 'USD',
      dlv_val: total_price,
      ecommerce: {
          items: [{
              item_name: product_name,
              item_id: product_id,
              price: total_price,
              item_brand: sku_word,
              quantity: '1',
              currency: 'USD',
          }]
      }
  });
}

